// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-11-02T21:16:29.573Z
// Property: Palmetto Pointe (ID: 5757666374713344)
// Collections: 26 amenities, 10 floorplans (live), 35 photos, 80 POIs, 4 reviews, 1 virtual tours, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5695708787113984",
  "multihub_property_id": "5757666374713344",
  "property_external_id": "4878141",
  "property_zillow_url": "https://www.zillow.com/apartments/san-antonio-tx/4835-usaa-blvd/BZSDjr/",
  "property_apartments_url": "https://www.apartments.com/palmetto-pointe-san-antonio-tx/0e8hnl3",
  "property_google_business_url": "https://www.google.com/maps/place/Palmetto+Pointe/@29.5364577,-98.5837672,17z/data=!4m13!1m7!3m6!1s0x865c67ed7f046255:0xc98006394d1a5ca5!2s4835+USAA+Blvd,+San+Antonio,+TX+78240!3b1!8m2!3d29.5364577!4d-98.5815732!3m4!1s0x865c67daa466da87:0xda40858d18f67b77!8m2!3d29.5364389!4d-98.5816357",
  "property_linkedin_url": null,
  "property_hubspot_id": "8443907421",
  "property_crm_software": "Rent Dynamics",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "palmetto-pointe",
  "property_name": "Palmetto Pointe",
  "property_website_url": "https://www.palmettopointeliving.com/",
  "property_domain": "https://www.palmettopointeliving.com/",
  "property_address": "4835 Usaa Blvd",
  "property_full_address": "4835 Usaa Blvd, San Antonio, TX 78240",
  "property_address_1": "4835 Usaa Blvd",
  "property_address_2": null,
  "property_address_city": "San Antonio",
  "property_address_state": "TX",
  "property_address_zip_full": "78240-3273",
  "property_address_zip": "78240",
  "property_address_country": "US",
  "property_address_county": "Bexar County",
  "property_neighborhood_address": "Northwest Side",
  "property_address_latitude": "29.5370282",
  "property_address_longitude": "-98.5809227",
  "property_email": "palmetto@alapts.com",
  "property_phone": "(210) 667-4835",
  "property_call_tracking_phone": "830-396-6863",
  "property_company_name": "American Landmark",
  "property_company_url": "https://www.alapts.com/",
  "agency_contacts": null,
  "property_type": "apartment",
  "property_short_description": "<p><strong>Upscale Medical Center living starts here.</strong> Explore spacious one- and two-bedroom apartments with polished finishes, private patios, and resort-style spaces designed for easy downtime—then schedule your tour of Palmetto Pointe today.</p>",
  "property_long_description": "<p><strong>Upscale apartment living in San Antonio’s Medical Center.</strong> At Palmetto Pointe, you’re close to South Texas Medical Center, UT Health San Antonio, University Hospital, Methodist Hospital, and the everyday dining and shopping along Huebner Road, with Loop 410 and I-10 nearby for smooth citywide access.</p><p>Choose from spacious <a href=\"/floor-plans\">one- and two-bedroom floor plans</a> with polished finishes like quartz countertops, stainless steel appliances, kitchen islands, wood-style and ceramic tile flooring, garden tubs, in-home washer and dryer sets, generous walk-in closets, and private patios. Beyond your front door, <a href=\"/amenities\">resort-style amenities</a> make downtime easy: relax by the poolside cabana with WiFi, gather around the dual-sided outdoor fireplace, grill in the outdoor kitchen, get moving in the fitness center or spin room, or settle into the business center and entertainment room. With gated access, available covered and garage parking, pet play areas, and 24/7 online resident services, Palmetto Pointe brings a polished, convenient rhythm to <a href=\"/neighborhood\">Medical Center living</a>.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019e89a7-7f16-7259-b0dc-b12f3e0625ab.webp",
  "property_featured_image_media": {
    "alt_text": "Resort-style swimming pool and lounge area at sunset.",
    "public_id": "019e89a7-7f16-7259-b0dc-b12f3e0625ab",
    "storage_key": "property/5757666374713344/019e89a7-7f16-7259-b0dc-b12f3e0625ab.webp",
    "width": 3072,
    "height": 2048
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "328",
  "property_year_built": "2020",
  "property_year_renovated": "2022",
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "94.51219512195121",
  "property_admin_fee": "150",
  "property_application_fee": "75",
  "property_fees_deposit_info": "Application Fee $75\nAdministrative Fee $150\nNon-Refundable Pet Fee $300 / pet\nMonthly Pet Rent $25 / pet\nApplication Approval Fee Starting At $300\n",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "300",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "25",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "Breed restrictions may apply. Contact us for more information.",
  "property_pet_policy_description": "We happily accept cats and dogs, up to 2 per home, with no weight limit. We have a one-time non-refundable pet fee of $300 per pet, with a monthly pet rent of $25 per pet. Breed restrictions may apply.",
  "property_petpolicy_info": "We happily accept cats and dogs, up to 2 per home, with no weight limit. We have a one-time non-refundable pet fee of $300 per pet, with a monthly pet rent of $25 per pet. Breed restrictions may apply.",
  "property_online_leasing_url": "https://8760952.onlineleasing.realpage.com",
  "property_resident_portal_url": "https://palmettopointe.loftliving.com/login",
  "property_apply_now_url": "https://8760952.onlineleasing.realpage.com",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019e700a-597a-777a-a5ef-fb1669d40b5a.webp",
  "property_primary_logo_media": {
    "alt_text": "Palmetto Pointe Premier Apartments logo with a gold palm leaf in a grey square.",
    "public_id": "019e700a-597a-777a-a5ef-fb1669d40b5a",
    "storage_key": "property/5757666374713344/019e700a-597a-777a-a5ef-fb1669d40b5a.webp",
    "width": 1835,
    "height": 753
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019e700a-5993-73b4-9729-78e410c53f23.webp",
  "property_secondary_logo_media": {
    "alt_text": "Palmetto Pointe Premier Apartments logo with a golden palm frond inside a square outline.",
    "public_id": "019e700a-5993-73b4-9729-78e410c53f23",
    "storage_key": "property/5757666374713344/019e700a-5993-73b4-9729-78e410c53f23.webp",
    "width": 1083,
    "height": 1241
  },
  "property_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019e700a-5ac4-725b-913a-9a7f16faba94.webp",
  "property_icon_media": {
    "alt_text": "Golden feather inside a square, on a black background.",
    "public_id": "019e700a-5ac4-725b-913a-9a7f16faba94",
    "storage_key": "property/5757666374713344/019e700a-5ac4-725b-913a-9a7f16faba94.webp",
    "width": 1050,
    "height": 1050
  },
  "property_fav_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019e700a-5ac4-725b-913a-9a7f16faba94.webp",
  "property_fav_icon_media": {
    "alt_text": "Golden feather inside a square, on a black background.",
    "public_id": "019e700a-5ac4-725b-913a-9a7f16faba94",
    "storage_key": "property/5757666374713344/019e700a-5ac4-725b-913a-9a7f16faba94.webp",
    "width": 1050,
    "height": 1050
  },
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019e700a-596e-7349-9900-85436aa2ba57.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Palmetto Pointe Premier Apartments logo with a palm frond graphic.",
    "public_id": "019e700a-596e-7349-9900-85436aa2ba57",
    "storage_key": "property/5757666374713344/019e700a-596e-7349-9900-85436aa2ba57.webp",
    "width": 1602,
    "height": 506
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f4317-9fdd-757c-a1c8-0815a27f0ae6.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "019f4317-9fdd-757c-a1c8-0815a27f0ae6",
    "storage_key": "property/5757666374713344/019f4317-9fdd-757c-a1c8-0815a27f0ae6.webp",
    "width": 1280,
    "height": 525
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-af4c-707a-be5f-eaefee6b31cf.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-c9dc-7579-9b73-fbe42f847d6f.webp",
  "property_company_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019d02ed-c9dc-7579-9b73-fbe42f847d6f",
    "storage_key": "company/5695708787113984/019d02ed-c9dc-7579-9b73-fbe42f847d6f.webp",
    "width": 1968,
    "height": 884
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-b73c-7581-ab8a-b01c3434f867.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019d02ed-b73c-7581-ab8a-b01c3434f867",
    "storage_key": "company/5695708787113984/019d02ed-b73c-7581-ab8a-b01c3434f867.webp",
    "width": 2565,
    "height": 1000
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5695708787113984/019d02ed-bfec-74fd-b5d0-5a699636306b.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "American Landmark logo on a black background",
    "public_id": "019d02ed-bfec-74fd-b5d0-5a699636306b",
    "storage_key": "company/5695708787113984/019d02ed-bfec-74fd-b5d0-5a699636306b.webp",
    "width": 2565,
    "height": 1000
  },
  "property_primary_color": "#eabb4e",
  "property_secondary_color": "#000000",
  "property_font_color": "#2e2a25",
  "property_color_4": null,
  "property_color_3": "#4b4d51",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 2",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "653 - 1451",
  "property_sqft_min": "653",
  "property_sqft_max": "1451",
  "property_price_range": "1193.5 - 1940",
  "property_price_min": "1193.5",
  "property_price_max": "1940",
  "property_available_units": 18,
  "property_facebook_url": "https://www.facebook.com/PalmettoPointeApartmentsSA",
  "property_instagram_url": "https://www.instagram.com/palmetto_pointe",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJh9pmpNpnXIYRd3v2GI2FQNo",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/biz/palmetto-pointe-san-antonio-2",
  "property_tiktok_url": "https://www.tiktok.com/@palmettopointe",
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": null,
  "property_home_romance_title": null,
  "property_home_amenities_blurb": "<p><strong>Amenity spaces that keep the day moving.</strong> Break a sweat in the fitness center or spin room, cool off at the resort-style pool, then settle in by the cabana with WiFi. Outdoor gas grills, a dual-sided fireplace with TVs, billiards lounge, and an entertainment room with a full kitchen add polished places to gather, while apartment finishes like quartz countertops, stainless steel appliances, 9-foot ceilings, walk-in closets, garden tubs, and in-home laundry bring the comfort back inside.</p>",
  "property_home_floorplans_blurb": "<p><strong>One- and two-bedroom layouts with polished everyday details.</strong> At Palmetto Pointe, floor plans in San Antonio’s Medical Center pair easy-flowing spaces with quartz countertops, stainless steel appliances, designer cabinetry, and full-size washer and dryer sets. Select homes add kitchen islands or pantries, while features like 9-foot ceilings, wood-style and ceramic tile flooring, walk-in closets, garden tubs, and private patios bring extra comfort to the plans you’ll want to explore.</p>",
  "property_home_gallery_blurb": "<p><strong>Picture Palmetto Pointe in detail.</strong> Preview bright kitchens with quartz countertops and island seating, wood-style flooring, sleek cabinetry, and living spaces that open to a private patio. Then glimpse the resort-style pool, shaded cabanas, outdoor kitchen, and lounge with billiards before opening the full gallery.</p>",
  "property_home_neighborhood_blurb": "<p><strong>Calmer Northwest San Antonio, connected to the Medical Center.</strong> From Palmetto Pointe, Medical Drive, Huebner Road errands, Magnolia Pancake Haus, and Gino’s Deli are all close to home. Green time comes easy with Leon Vista Park, Leon Creek Greenway, and Gorrell Park nearby, while VIA access and Fredericksburg Road keep the rest of San Antonio within reach.</p>",
  "property_home_reviews_blurb": "<p><strong>Real feedback, real reasons to love it.</strong><br>Palmetto Pointe reviews highlight a helpful, patient leasing team, beautiful apartment homes, and a calm, well-kept setting near the Medical Center. Residents mention spacious-feeling layouts, upgraded appliances, clean community spaces, quiet surroundings, and friendly neighbors—plus service that makes the experience feel personal from tour to move-in. Read the full reviews to see what everyday life here is like.</p>",
  "property_neighborhood_blurb": "<p><strong>Map your Medical Center routine from a calmer Northwest San Antonio setting.</strong> Around Palmetto Pointe, daily essentials and after-hours plans sit close together: Medical Drive’s care and research corridor, Huebner Road errands, and local favorites like Magnolia Pancake Haus and Gino’s Deli when you want something easy but memorable. For fresh air, head toward Leon Vista Park and the Leon Creek Greenway, or keep it simple with a quick stop at Gorrell Park. VIA connections at Medical Center Transit Center and access to Fredericksburg Road help keep more of San Antonio within reach. Start with the interactive map, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see how the neighborhood connects back to home.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p><strong>Space to work out, wind down, and entertain—without leaving home.</strong> At Palmetto Pointe, your amenity lineup is built around easy transitions: start with a session in the fitness center or spin room, cool off at the resort-style pool, then linger under the poolside cabana with WiFi. When plans call for gathering, the outdoor kitchen with gas grills, dual-sided fireplace with TVs, billiards lounge, and entertainment room with a fully equipped kitchen give you polished places to spread out.</p><p>Inside your apartment, the everyday upgrades feel just as considered, from quartz countertops and stainless steel appliances to 9-foot ceilings, walk-in closets, garden tubs, and an in-home washer and dryer. Browse the <a href=\"/gallery\">photo gallery</a>, then <a href=\"/schedule-a-tour\">schedule a tour</a> to experience the amenities in person.</p>",
  "property_applynow_blurb": "<p><strong>Ready to call Palmetto Pointe home?</strong> Start your online application for upscale Medical Center apartment living with spacious one- and two-bedroom layouts, polished in-home finishes, and resort-style spaces designed for everyday ease. Apply today and take the next step toward a smoother, more convenient San Antonio lifestyle.</p>",
  "property_contactus_blurb": "<p><strong>Have questions about Palmetto Pointe?</strong><br>Our leasing team is here to help with availability, directions, and details on upscale Medical Center apartment living—from spacious one- and two-bedroom homes to polished finishes and resort-style spaces. Reach out today and let us point you in the right direction.</p>",
  "property_faqs_blurb": "<p><strong>Questions about Palmetto Pointe?</strong> Start here for quick answers about leasing, spacious one- and two-bedroom apartments, polished finishes, resort-style amenities, parking, pets, and online resident services. If you need anything else, the leasing team is happy to help.</p>",
  "property_floorplans_blurb": "<p><strong>Find the layout that fits your day.</strong> Browse Palmetto Pointe’s one- and two-bedroom apartment floor plans in San Antonio’s Medical Center, from efficient spaces with easy flow to larger layouts with room to spread out. Inside, everyday details feel considered: quartz countertops, stainless steel appliances, designer cabinetry, kitchen islands or pantries in select homes, and full-size washer and dryer sets.</p><p>As you compare available plans, look for the comforts that make each home feel complete—9-foot ceilings, wood-style and ceramic tile flooring, generous walk-in closets, garden tubs, and a private patio for a little fresh air. Ready to see the finishes up close? Explore the <a href=\"/gallery\">photo gallery</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to walk your favorite layout.</p>",
  "property_gallery_blurb": "<p><strong>See the details before you tour.</strong> Browse Palmetto Pointe in pictures, from bright kitchens with quartz countertops and island seating to living spaces that open toward your private patio. The gallery gives you a closer look at the textures that shape each apartment—wood-style flooring, sleek cabinetry, and calm, modern finishes that photograph as well as they feel.</p><p>Keep scrolling to picture downtime around the <a href=\"/amenities\">resort-style pool</a>, shaded cabana seating, the outdoor kitchen, and the lounge with billiards and flat-screen TVs. When a photo catches your eye, compare available <a href=\"/floor-plans\">one- and two-bedroom layouts</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see Palmetto Pointe in person.</p>",
  "property_interactivemap_blurb": "<p><strong>Explore Palmetto Pointe on the map.</strong><br>See available apartments in San Antonio’s Medical Center area, then zoom out to find nearby dining, shopping, and convenient access to Loop 410 and I-10—all from one interactive view.</p>",
  "property_pets_blurb": "<p><strong>Pet-friendly living with daily ease.</strong> At Palmetto Pointe, cats and dogs have space to settle in, with up to two pets per home and no weight limit. Start the day with a quick romp in the on-site pet play area, then enjoy the simple comforts that make pet care smoother—private patios in select homes, door-to-door trash pickup, and <a href=\"/amenities\">community spaces</a> made for an easy routine.</p><p>When your dog needs a bigger adventure, nearby Phil Hardberger Park offers off-leash dog parks with separate areas, trails, and shaded natural space. Ready to picture life here with your pet? <a href=\"/schedule-a-tour\">Schedule a tour</a> and explore the spaces that make Palmetto Pointe feel like home.</p>",
  "property_referafriend_blurb": "<p><strong>Share the Palmetto Pointe experience.</strong> If you love the polished finishes, spacious one- and two-bedroom layouts, and resort-style spaces that make downtime easy, invite a friend to see it for themselves. Send a referral today and help them discover upscale apartment living in San Antonio’s Medical Center.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident Access at Palmetto Pointe.</strong><br>Keep daily details simple with 24/7 online resident services. Log in anytime to pay rent, submit maintenance requests, and manage your account—all part of the polished, convenient rhythm of Medical Center living.</p>",
  "property_reviews_blurb": "<p><strong>Hear what living here feels like.</strong><br>Residents consistently point to Palmetto Pointe’s welcoming team, beautiful apartment homes, and calm, well-kept setting as reasons they’re glad they chose this community. From first tours to lease questions, reviewers call out helpful, patient service from the office staff, with one resident saying, “We feel at home.”</p><p>As you browse the reviews, you’ll see praise for spacious-feeling layouts, upgraded appliances, clean community spaces, and a convenient Medical Center location. Many comments also highlight a quiet atmosphere and friendly neighbors—details that help paint a real picture of day-to-day life at Palmetto Pointe.</p>",
  "property_created_at": "1752256720035",
  "property_scheduletour_blurb": "<p><strong>See Palmetto Pointe in person.</strong> Tour spacious one- and two-bedroom apartments with quartz countertops, stainless steel appliances, garden tubs, walk-in closets, and private patios—then take in the poolside cabana, outdoor fireplace, fitness spaces, and polished everyday conveniences. Schedule your visit today.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you for reaching out to Palmetto Pointe.</strong><br>Your inquiry has been received, and the leasing team will follow up soon. In the meantime, picture upscale Medical Center living with spacious one- and two-bedroom layouts, polished finishes, and resort-style spaces designed for easy downtime.</p>",
  "property_virtualtours_blurb": "<p><strong>Walk through Palmetto Pointe from wherever you are.</strong> Start with the community virtual tours for a feel for the grounds, then step inside the clubhouse to see the shared spaces that shape everyday downtime. From there, compare the available apartment walkthroughs: a 1-bedroom, 1-bath home and a 2-bedroom, 2-bath layout, each giving you a closer look at the flow, finishes, storage, and private outdoor space that photos can only hint at.</p><p>Use each tour to pause, turn, and revisit the details that matter before you choose your next step. When you’re ready, browse <a href=\"/floor-plans\">available floor plans</a>, see more angles in the <a href=\"/gallery\">photo gallery</a>, or <a href=\"/schedule-a-tour\">schedule an in-person tour</a> to experience Palmetto Pointe in San Antonio firsthand.</p>",
  "property_copyright": "2025 All Rights Reserved. Palmetto Pointe",
  "property_seo_title_home": "Palmetto Pointe | Apartments in San Antonio, TX",
  "property_seo_description_home": "Discover your perfect sanctuary at Palmetto Pointe in San Antonio, TX! Our modern one and two-bedroom apartment floor plans boast stunning amenities like a state-of-the-art fitness center, resort-style pool, and stylish outdoor kitchen. Enjoy luxurious features including quartz countertops, stainless steel appliances, generous walk-in closets, and garden tubs. Experience convenience with online resident services and covered parking. Explore all that Palmetto Pointe has to offer and elevate your living experience. Find your new home today!",
  "property_seo_title_floorplans": "Floor Plans | 1 - 2 Apartments in San Antonio, TX",
  "property_seo_description_floorplans": "Discover your ideal living space at Palmetto Pointe in San Antonio, TX! Explore our thoughtfully designed floor plans featuring one-bedroom and two-bedroom apartments. Ready to find your perfect fit? Browse our available apartment homes today and envision your new lifestyle!",
  "property_seo_title_amenities": "Amenities | San Antonio, TX Apartments for Rent",
  "property_seo_description_amenities": "Discover the vibrant lifestyle at Palmetto Pointe in San Antonio, TX! Choose from spacious one and two-bedroom floor plans, complete with modern features like quartz countertops, stainless steel appliances, and generous walk-in closets. Enjoy resort-style amenities, including a sparkling pool, fitness center, outdoor kitchen, clubhouse, and online resident services. Dive into comfort and convenience—explore our amazing community amenities and apartment features today!",
  "property_seo_title_gallery": "Gallery | Apartments in San Antonio, TX",
  "property_seo_description_gallery": "\"Discover your ideal living space at Palmetto Pointe in San Antonio, TX! Explore our stunning photo gallery showcasing luxurious One and Two Bedroom floor plans with top-notch amenities including a fitness center, outdoor kitchen, and beautiful garden tubs. Picture yourself enjoying our clubhouse, billiards, and inviting outdoor fireplace! Experience modern living with designer cabinetry, quartz countertops, walk-in closets, and more. Your dream home awaits—visit us to see it all!\"",
  "property_seo_title_virtualtours": "Virtual Tours | Palmetto Pointe Apartments",
  "property_seo_description_virtualtours": "Explore the comfort of Palmetto Pointe in San Antonio, TX! Discover our diverse floor plans, featuring both one and two-bedroom apartments. Take a virtual tour today and see why our community is the perfect place to call home. Don't miss your chance—explore your future home now!",
  "property_seo_title_interactivemap": "Interactive Map | Palmetto Pointe Apartments",
  "property_seo_description_interactivemap": "Discover your dream home at Palmetto Pointe in vibrant San Antonio, TX! Explore our spacious one and two-bedroom floor plans featuring stylish kitchens with stainless steel appliances, quartz countertops, and walk-in closets. Enjoy top-notch amenities like a refreshing pool, fitness center, and outdoor kitchen, along with convenient online resident services. Use our interactive community map to search available apartments, view pricing, and secure your new home today!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in San Antonio, TX",
  "property_seo_description_neighborhood": "Discover the vibrant neighborhood surrounding Palmetto Pointe in San Antonio, TX! Explore local favorites and nearby points of interest, all just steps away from our charming community. Whether you're looking for a cozy one-bedroom or a spacious two-bedroom apartment, your perfect home awaits. Dive into the best of the area and see what's around our community today!",
  "property_seo_title_contact": "Contact Us | Palmetto Pointe",
  "property_seo_description_contact": "Discover your perfect home at Palmetto Pointe in San Antonio, TX! Explore our spacious one and two-bedroom floor plans designed for comfort and convenience. Have questions? Contact our leasing team today for personalized assistance and to learn more about our vibrant community!",
  "property_seo_title_faqs": "FAQs | Apartments in San Antonio, TX",
  "property_seo_description_faqs": "Explore Palmetto Pointe in San Antonio, TX! Our diverse floor plans offer both one and two-bedroom options with luxurious amenities including a state-of-the-art fitness center, refreshing pool, and stylish clubhouse. Enjoy modern features like quartz countertops, stainless steel appliances, and generous walk-in closets. Have questions? Browse our FAQs page for all the answers about community living and lifestyle at Palmetto Pointe. Your new home awaits!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in San Antonio, TX",
  "property_seo_description_reviews": "Discover why residents love calling Palmetto Pointe home in San Antonio, TX! With a range of spacious one- and two-bedroom floor plans, top-tier amenities—including a fitness center, billiards lounge, and outdoor kitchen—and stylish features like quartz countertops and stainless steel appliances, there’s something for everyone. Don't just take our word for it; see what our residents have to say about their experience at our vibrant community!",
  "property_seo_title_applynow": "Apply Now | Apartments in San Antonio, TX",
  "property_seo_description_applynow": "Discover your dream home at Palmetto Pointe in San Antonio, TX! Our vibrant apartment community offers stylish one and two-bedroom floor plans equipped with modern amenities like quartz countertops, stainless steel appliances, and garden tubs. Enjoy a wealth of community features, including a fitness center, an outdoor kitchen, and a refreshing pool. With online resident services and convenient covered parking, you'll feel right at home. Don’t wait—find your new home and lease online today!",
  "property_seo_title_residentaccess": "Resident Access | Palmetto Pointe",
  "property_seo_description_residentaccess": "\"Log in to your Palmetto Pointe resident portal in San Antonio, TX, to effortlessly pay rent, schedule maintenance, and access essential community resources. Simplify your living experience today!\"",
  "property_seo_title_referafriend": "Refer A Friend | Palmetto Pointe",
  "property_seo_description_referafriend": "\"Discover the vibrant community at Palmetto Pointe in San Antonio, TX! Great friends make great neighbors—refer a friend today and enjoy exclusive rewards. Join us for a lifestyle filled with comfort, connection, and fun!\"",
  "property_seo_title_scheduletour": "Schedule a Tour | Palmetto Pointe",
  "property_seo_description_scheduletour": "Discover your future home at Palmetto Pointe in San Antonio, TX! Experience our vibrant community and modern amenities. Schedule a tour today and take the first step towards your dream apartment!",
  "property_seo_title_privacy": "Privacy Policy | Palmetto Pointe",
  "property_seo_description_privacy": "Discover how we safeguard your information at Palmetto Pointe in San Antonio, TX. Our privacy policy outlines our commitment to your privacy and data protection. View our privacy policy today to learn more about your rights and our practices.",
  "property_seo_title_accessibility": "Website Accessibility | Palmetto Pointe",
  "property_seo_description_accessibility": "Discover Palmetto Pointe in San Antonio, TX—where we prioritize accessibility and digital inclusion for all residents. Explore our comprehensive Accessibility Statement to learn how we strive to create an inclusive living environment. Join us in making every experience seamless—your comfort is our commitment!",
  "property_seo_title_sitemap": "Sitemap | Palmetto Pointe",
  "property_seo_description_sitemap": "\"Explore Palmetto Pointe in San Antonio, TX! Discover our community's offerings, amenities, and services through our detailed sitemap. Navigate easily and find the perfect apartment for your lifestyle. View our website sitemap today!\"",
  "property_seo_title_thankyou": "Thank You | Palmetto Pointe",
  "property_seo_description_thankyou": "Thank you for reaching out to Palmetto Pointe in San Antonio, TX! Your inquiry is important to us, and a member of our friendly team will be in touch shortly. Explore your future home in our vibrant community, where comfort and convenience meet. Stay tuned for more information!",
  "property_seo_title_pets": "Pet Policy | Apartments in Jacksonville, FL\r",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791234320223",
  "amenities": [
    {
      "id": "custom_a9f56eb7-c446-49fb-bbc0-cb0abd83c35a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "source": "custom",
      "external_id": "P000000597",
      "title": "American Landmark 360",
      "amount": "0.0000",
      "description": "American Landmark 360 Resident Program",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_85352627-a01e-43cf-b34e-a834f7b304c4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "source": "custom",
      "external_id": "P000000607",
      "title": "Business Center",
      "amount": "0.0000",
      "description": "Business Center w/ High Speed-Internet",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b1dcce80-555d-4dc2-ba93-f849f59ff006",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "source": "custom",
      "external_id": "P000000608",
      "title": "Cabana",
      "amount": "0.0000",
      "description": "Poolside Cabana w/ WiFi",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_49c953ab-cd8f-4e5f-8e8b-c895e724f5a4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "source": "custom",
      "external_id": "P000000609",
      "title": "Cabinets",
      "amount": "0.0000",
      "description": "Designer Cabinetry",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_6930c22f-e283-49e4-a87b-b31880e43dc6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "source": "custom",
      "external_id": "P000000614",
      "title": "Clubhouse",
      "amount": "0.0000",
      "description": "Entertainment Room w/ Fully-Equipped Kitchen",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f8acfa8e-06c0-4cf5-84bc-8b44bb6654ab",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "source": "custom",
      "external_id": "P000000621",
      "title": "Counters",
      "amount": "0.0000",
      "description": "Quartz Countertops",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_5c0ba0bd-18ac-467f-b79c-84634b45884a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "source": "custom",
      "external_id": "P000000623",
      "title": "Covered Parking",
      "amount": "0.0000",
      "description": "Covered & Garage Parking Available",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_66c58597-3510-4596-ad18-94eb7fa955a2",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "source": "custom",
      "external_id": "P000000632",
      "title": "Fenced Yard",
      "amount": "0.0000",
      "description": "Private Patios",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_eb230409-860a-4a0f-aea7-a1dfb8adca2b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "source": "custom",
      "external_id": "P000000635",
      "title": "Fitness Center",
      "amount": "0.0000",
      "description": "Modern 24-Hour Fitness Center",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_41ae538a-af69-46b7-b21f-30156cd2dc48",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "source": "custom",
      "external_id": "P000000641",
      "title": "Garden Tub",
      "amount": "0.0000",
      "description": "Garden Tubs",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_dab0b20c-c980-47b4-adde-6b79c20c623d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "source": "custom",
      "external_id": "P000000646",
      "title": "Hard Floors",
      "amount": "0.0000",
      "description": "Wood Style & Ceramic Tile Flooring",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_9de70d14-8853-499f-bb56-b4b30ba63623",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "source": "custom",
      "external_id": "P000000651",
      "title": "Kitchen Appliances",
      "amount": "0.0000",
      "description": "Stainless Steel Appliances",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_0c5e4a6a-60a8-4b6d-8a7f-081d32be8341",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "source": "custom",
      "external_id": "P000000652",
      "title": "Kitchen Islands",
      "amount": "0.0000",
      "description": "Kitchen Islands",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_935818de-d1ff-46e4-b15a-364001150910",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "source": "custom",
      "external_id": "P000000660",
      "title": "Online Resident Services",
      "amount": "0.0000",
      "description": "Convenient 24/7 Online Resident Services",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_2b784ead-6540-4e35-8b79-68a32aba9896",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "source": "custom",
      "external_id": "P000000662",
      "title": "Outdoor Kitchen",
      "amount": "0.0000",
      "description": "Outdoor Kitchen w/ Gas Grills",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_2b84548b-59f8-45a8-8d32-bb3a2eaee989",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "source": "custom",
      "external_id": "P000000663",
      "title": "Outside Space",
      "amount": "0.0000",
      "description": "Private Patio",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_96a5233b-2054-4dd5-b4a9-aa8ed401e73f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "source": "custom",
      "external_id": "P000000666",
      "title": "Pantry Closets",
      "amount": "0.0000",
      "description": "Kitchen Pantry",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_0cb17676-588c-4662-802c-9f33f9070c6c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "source": "custom",
      "external_id": "P000000669",
      "title": "Pool",
      "amount": "0.0000",
      "description": "Resort-Inspired Pool",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_80cc1015-cab4-4768-8424-a4af54063105",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "source": "custom",
      "external_id": "P000000684",
      "title": "Spin Room",
      "amount": "0.0000",
      "description": "Spin Room",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_bb7e81c5-a0e5-4bdd-a404-ce66fd311c25",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "source": "custom",
      "external_id": "P000000690",
      "title": "Tall Ceilings",
      "amount": "0.0000",
      "description": "9` Ceilings",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c4b57239-a0a1-4bea-b150-1daa29291334",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "source": "custom",
      "external_id": "P000000704",
      "title": "W&D Included",
      "amount": "0.0000",
      "description": "In-Home Washer and Dryers",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_50aed82a-5313-4a33-89ef-bd1cb160613c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "source": "custom",
      "external_id": "P000000705",
      "title": "Walk-In Closet",
      "amount": "0.0000",
      "description": "Generous Walk-In Closets",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_4d4d2596-6746-496b-90e3-2c18a4c5e432",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "source": "custom",
      "external_id": "P000002464",
      "title": "Outdoor Fireplace",
      "amount": "0.0000",
      "description": "Dual-Sided Grand Outdoor Fireplace",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ec61dc65-8596-4054-a0b8-fe05c6c6d59c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "source": "custom",
      "external_id": "P000002475",
      "title": "Game Room with Billiards",
      "amount": "0.0000",
      "description": "Billiards Table & Flat Screen TVs",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_2c89c29c-88a8-44bd-85c0-fa62322d5693",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "source": "custom",
      "external_id": "P000002561",
      "title": "RentPlus",
      "amount": "0.0000",
      "description": "Credit Building powered by RentPlus",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_9cb48d75-de68-4135-99c1-d5212f78c515",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "source": "custom",
      "external_id": "P000002563",
      "title": "Spruce",
      "amount": "0.0000",
      "description": "Spruce",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_e39c6961-92f0-40d2-87a4-5f0cd4b3c259",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019e89a8-8dcf-742f-9fe7-d9bef25efca2.webp",
      "image_media": {
        "alt_text": "Modern living room with a gray sofa, colorful rug, and abstract art.",
        "public_id": "019e89a8-8dcf-742f-9fe7-d9bef25efca2",
        "storage_key": "property/5757666374713344/019e89a8-8dcf-742f-9fe7-d9bef25efca2.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Step into a stylish living room featuring a comfortable gray sofa adorned with vibrant accent pillows, a richly patterned rug, and captivating abstract artwork.",
      "link": "",
      "alt_text": "Modern living room with a gray sofa, colorful rug, and abstract art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_0898e309-8023-4f59-a91e-502e0e72c9d1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019e89a8-25fb-709d-99ce-3270f0f052d3.webp",
      "image_media": {
        "alt_text": "Living room with blue sofa and abstract art, view into bedroom.",
        "public_id": "019e89a8-25fb-709d-99ce-3270f0f052d3",
        "storage_key": "property/5757666374713344/019e89a8-25fb-709d-99ce-3270f0f052d3.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Stylish living room featuring a plush blue sofa, modern decor, and access to a serene bedroom. Perfect for relaxation and comfort.",
      "link": "",
      "alt_text": "Living room with blue sofa and abstract art, view into bedroom.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_acdefac2-b47d-45c2-bae2-f5ba78a9061a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019e89a8-2518-73b1-8986-16230156a3e5.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with balconies and exterior staircases.",
        "public_id": "019e89a8-2518-73b1-8986-16230156a3e5",
        "storage_key": "property/5757666374713344/019e89a8-2518-73b1-8986-16230156a3e5.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Showcasing the beautiful exteriors of our apartment buildings, featuring spacious balconies and accessible exterior staircases.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with balconies and exterior staircases.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_0f475019-32bf-4806-9858-807b7bc9c50a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019e89a8-2567-744e-b9e5-da9e1ea16938.webp",
      "image_media": {
        "alt_text": "Stylish lounge area with large windows overlooking the pool and apartment buildings.",
        "public_id": "019e89a8-2567-744e-b9e5-da9e1ea16938",
        "storage_key": "property/5757666374713344/019e89a8-2567-744e-b9e5-da9e1ea16938.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind in the sophisticated lounge, featuring comfortable seating and a stunning view of the community pool and exterior.",
      "link": "",
      "alt_text": "Stylish lounge area with large windows overlooking the pool and apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_212e9c80-bd42-4279-b9de-576b6cf5a586",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019e89a8-2486-720e-a867-b01b159b3f11.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, island with bar stools, and contemporary decor.",
        "public_id": "019e89a8-2486-720e-a867-b01b159b3f11",
        "storage_key": "property/5757666374713344/019e89a8-2486-720e-a867-b01b159b3f11.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Step into a beautifully designed kitchen featuring stainless steel appliances, a spacious island with comfortable bar stools, and chic, modern finishes. Perfect for cooking and entertaining.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances, island with bar stools, and contemporary decor.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a47e97a0-2f6e-4b77-9b58-e755d3faefcc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019e89a8-1037-75e1-b40e-43581d98a8d5.webp",
      "image_media": {
        "alt_text": "Gym with weight machines, dumbbells, and punching bags.",
        "public_id": "019e89a8-1037-75e1-b40e-43581d98a8d5",
        "storage_key": "property/5757666374713344/019e89a8-1037-75e1-b40e-43581d98a8d5.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "State-of-the-art fitness center with a variety of weight machines, free weights, and cardio equipment. Enjoy a great workout in our fully equipped gym.",
      "link": "",
      "alt_text": "Gym with weight machines, dumbbells, and punching bags.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b4663327-e27d-40ee-ad21-294389a91160",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019e89a8-0ff2-7189-89a0-4f149d2801e6.webp",
      "image_media": {
        "alt_text": "Luxurious community lounge with a billiards table, modern seating, and a large TV.",
        "public_id": "019e89a8-0ff2-7189-89a0-4f149d2801e6",
        "storage_key": "property/5757666374713344/019e89a8-0ff2-7189-89a0-4f149d2801e6.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy leisure and relaxation in our sophisticated community lounge, featuring a billiards table, stylish seating areas, and entertainment options.",
      "link": "",
      "alt_text": "Luxurious community lounge with a billiards table, modern seating, and a large TV.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ddf44e3b-57f9-4213-97b2-5ebbc49fb35d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019e89a8-1048-7224-b1b9-23c411b8973e.webp",
      "image_media": {
        "alt_text": "Outdoor kitchen and seating area with a swimming pool in the background.",
        "public_id": "019e89a8-1048-7224-b1b9-23c411b8973e",
        "storage_key": "property/5757666374713344/019e89a8-1048-7224-b1b9-23c411b8973e.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy outdoor living with this spacious outdoor kitchen, complete with a grill and bar seating, adjacent to a sparkling swimming pool.",
      "link": "",
      "alt_text": "Outdoor kitchen and seating area with a swimming pool in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_fa0fd2c6-e120-40ff-be57-97c6bf964042",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019e89a8-1037-73a4-94ef-fba6e3d3d50e.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-size bed, blue bedding, and a ceiling fan.",
        "public_id": "019e89a8-1037-73a4-94ef-fba6e3d3d50e",
        "storage_key": "property/5757666374713344/019e89a8-1037-73a4-94ef-fba6e3d3d50e.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a king-size bed with comfortable blue bedding, a modern ceiling fan, and decorative artwork.",
      "link": "",
      "alt_text": "Bedroom with a king-size bed, blue bedding, and a ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_87b7205c-edbc-4c72-b9e9-c4fe6342251e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019e89a7-fed4-7482-83f5-0fff045a6be9.webp",
      "image_media": {
        "alt_text": "Modern lounge area with a pool table, comfortable seating, and a full kitchen.",
        "public_id": "019e89a7-fed4-7482-83f5-0fff045a6be9",
        "storage_key": "property/5757666374713344/019e89a7-fed4-7482-83f5-0fff045a6be9.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy leisure time in our vibrant community lounge, featuring a billiards table, a stylish seating area, and a fully equipped gourmet kitchen.",
      "link": "",
      "alt_text": "Modern lounge area with a pool table, comfortable seating, and a full kitchen.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ca396cbc-4d6c-4393-b223-b4dca1b6a191",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019e89a7-febe-7298-a965-e82083a79c25.webp",
      "image_media": {
        "alt_text": "Modern open-concept living and kitchen area with stainless steel appliances and a large island.",
        "public_id": "019e89a7-febe-7298-a965-e82083a79c25",
        "storage_key": "property/5757666374713344/019e89a7-febe-7298-a965-e82083a79c25.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy spacious living with this open-concept apartment featuring a modern kitchen with a large island and sleek stainless steel appliances.",
      "link": "",
      "alt_text": "Modern open-concept living and kitchen area with stainless steel appliances and a large island.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_82085808-acd7-4f8b-8f36-0675a5a9969e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019e89a7-fecb-70db-97c0-fb425ef0a808.webp",
      "image_media": {
        "alt_text": "Modern kitchen with island, bar stools, stainless steel refrigerator, and wooden cabinetry.",
        "public_id": "019e89a7-fecb-70db-97c0-fb425ef0a808",
        "storage_key": "property/5757666374713344/019e89a7-fecb-70db-97c0-fb425ef0a808.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Experience luxury living in this modern kitchen featuring a spacious island, comfortable bar stools, sleek stainless steel appliances, and elegant wooden cabinetry.",
      "link": "",
      "alt_text": "Modern kitchen with island, bar stools, stainless steel refrigerator, and wooden cabinetry.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_2e64f4d4-f866-44f6-b6a5-ea7d016873a8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019e89a7-e8d4-776a-839b-5f85dc54ece1.webp",
      "image_media": {
        "alt_text": "Modern kitchen island with sink and stainless steel appliances, view into bedroom.",
        "public_id": "019e89a7-e8d4-776a-839b-5f85dc54ece1",
        "storage_key": "property/5757666374713344/019e89a7-e8d4-776a-839b-5f85dc54ece1.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen featuring a large island with a deep sink and ample counter space, perfect for cooking and entertaining. Stainless steel appliances add a sleek touch.",
      "link": "",
      "alt_text": "Modern kitchen island with sink and stainless steel appliances, view into bedroom.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_bda49930-b03e-4008-ad29-0a4048d716bc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019e89a7-ca38-741f-8c84-94747b39823d.webp",
      "image_media": {
        "alt_text": "Lush community lounge with plush seating, modern decor, and large windows overlooking the pool.",
        "public_id": "019e89a7-ca38-741f-8c84-94747b39823d",
        "storage_key": "property/5757666374713344/019e89a7-ca38-741f-8c84-94747b39823d.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and socialize in our stylish community lounge, featuring comfortable seating and scenic views of the resort-style pool.",
      "link": "",
      "alt_text": "Lush community lounge with plush seating, modern decor, and large windows overlooking the pool.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_5f13cafd-bf27-4714-b061-09d917d2c46c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019e89a7-cccd-7372-bcfb-f5680ff209ae.webp",
      "image_media": {
        "alt_text": "Stylish bedroom with a blue bed, yellow pillows, and modern art.",
        "public_id": "019e89a7-cccd-7372-bcfb-f5680ff209ae",
        "storage_key": "property/5757666374713344/019e89a7-cccd-7372-bcfb-f5680ff209ae.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Relax in this beautifully appointed bedroom featuring a plush blue bed, vibrant yellow accents, and contemporary artwork. A perfect sanctuary for rest and rejuvenation.",
      "link": "",
      "alt_text": "Stylish bedroom with a blue bed, yellow pillows, and modern art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_5f3982e1-d8ec-45ae-b631-9cd904a8fd09",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019e89a7-b341-70a8-aa3c-c1f7581b2657.webp",
      "image_media": {
        "alt_text": "Modern kitchen with island and living room view",
        "public_id": "019e89a7-b341-70a8-aa3c-c1f7581b2657",
        "storage_key": "property/5757666374713344/019e89a7-b341-70a8-aa3c-c1f7581b2657.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen with a large island, sleek cabinetry, and stainless steel appliances, opening into a well-appointed living area.",
      "link": "",
      "alt_text": "Modern kitchen with island and living room view",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b30362cd-0f27-4e79-b75c-3044d0c9b83a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019e89a7-b2e8-7016-a25d-e47d9d2f231c.webp",
      "image_media": {
        "alt_text": "Modern dining area with a long wooden table, brown leather chairs, and a statement chandelier.",
        "public_id": "019e89a7-b2e8-7016-a25d-e47d9d2f231c",
        "storage_key": "property/5757666374713344/019e89a7-b2e8-7016-a25d-e47d9d2f231c.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Gather around the stylish communal dining area, perfect for hosting friends or enjoying a quiet meal.",
      "link": "",
      "alt_text": "Modern dining area with a long wooden table, brown leather chairs, and a statement chandelier.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_0d168671-4f03-4d14-8dcb-b32f01988415",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019e89a7-b6d4-704c-af5e-7873a72f9ff3.webp",
      "image_media": {
        "alt_text": "Kitchen and entryway of an apartment with a large island and stainless steel appliances.",
        "public_id": "019e89a7-b6d4-704c-af5e-7873a72f9ff3",
        "storage_key": "property/5757666374713344/019e89a7-b6d4-704c-af5e-7873a72f9ff3.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Modern apartment kitchen featuring a spacious island, stainless steel appliances, and elegant cabinetry. The entryway is visible with dark doors.",
      "link": "",
      "alt_text": "Kitchen and entryway of an apartment with a large island and stainless steel appliances.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ed756a29-6ea5-4c1d-8ce4-88fa2884d970",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019e89a7-c031-71c9-ab3f-85d18e91ba73.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and modern apartment buildings in the background.",
        "public_id": "019e89a7-c031-71c9-ab3f-85d18e91ba73",
        "storage_key": "property/5757666374713344/019e89a7-c031-71c9-ab3f-85d18e91ba73.webp",
        "width": 2496,
        "height": 1664
      },
      "title": "Community",
      "description": "Enjoy the resort-style swimming pool and surrounding amenities at this luxury apartment community. Perfect for relaxing and soaking up the sun.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and modern apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a7146d76-1a30-4e98-a22d-1f9c9984fa37",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019e89a7-b27a-758a-9e87-85e0c53fc99d.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with in-water lounge chairs and lounge chairs on the sundeck.",
        "public_id": "019e89a7-b27a-758a-9e87-85e0c53fc99d",
        "storage_key": "property/5757666374713344/019e89a7-b27a-758a-9e87-85e0c53fc99d.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy our resort-style swimming pool, perfect for relaxing and soaking up the sun. Features in-water lounge chairs and a spacious sundeck.",
      "link": "",
      "alt_text": "Resort-style swimming pool with in-water lounge chairs and lounge chairs on the sundeck.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_bafcd678-e14f-4fef-a810-014a0cd7ecc8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019e89a7-b5b1-74e0-98f5-ee1014db7f6f.webp",
      "image_media": {
        "alt_text": "Covered outdoor lounge area with a fireplace, comfortable seating, and TVs.",
        "public_id": "019e89a7-b5b1-74e0-98f5-ee1014db7f6f",
        "storage_key": "property/5757666374713344/019e89a7-b5b1-74e0-98f5-ee1014db7f6f.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax by the fire or watch the game in this inviting outdoor lounge area, complete with plush seating and entertainment options.",
      "link": "",
      "alt_text": "Covered outdoor lounge area with a fireplace, comfortable seating, and TVs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_20fe1d89-0782-4f1a-b7b5-d68bc6a84f21",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019e89a7-b294-71ab-9a25-84542f5343d7.webp",
      "image_media": {
        "alt_text": "Living room and kitchen area of a modern apartment with blue sofa and island bar.",
        "public_id": "019e89a7-b294-71ab-9a25-84542f5343d7",
        "storage_key": "property/5757666374713344/019e89a7-b294-71ab-9a25-84542f5343d7.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Stylish living room featuring a comfortable blue sofa and a modern kitchen with an island bar, perfect for entertaining.",
      "link": "",
      "alt_text": "Living room and kitchen area of a modern apartment with blue sofa and island bar.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_5a5ee7b2-4f7f-4989-af43-508cffba1dbb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019e89a7-b3b5-70cf-a36d-3fa05e873498.webp",
      "image_media": {
        "alt_text": "Modern bathroom with double vanity and soaking tub.",
        "public_id": "019e89a7-b3b5-70cf-a36d-3fa05e873498",
        "storage_key": "property/5757666374713344/019e89a7-b3b5-70cf-a36d-3fa05e873498.webp",
        "width": 2995,
        "height": 1997
      },
      "title": "Apartment",
      "description": "This modern bathroom features a spacious double vanity, a soaking tub, and ample storage.",
      "link": "",
      "alt_text": "Modern bathroom with double vanity and soaking tub.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_70fe7cd4-f72c-4395-a55a-97b203660ac5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019e89a7-a9c4-76ba-b395-4e37568977f8.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool and fire pit area with seating in front of apartment buildings.",
        "public_id": "019e89a7-a9c4-76ba-b395-4e37568977f8",
        "storage_key": "property/5757666374713344/019e89a7-a9c4-76ba-b395-4e37568977f8.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling resort-style swimming pool or relax by the fire pit with friends and neighbors. Community amenities designed for your comfort and enjoyment.",
      "link": "",
      "alt_text": "Resort-style swimming pool and fire pit area with seating in front of apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a12990c6-3657-43e9-8fcd-6925c93f49d1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019e89a7-abc9-70ad-8f18-d6352b30da1b.webp",
      "image_media": {
        "alt_text": "Tanning bed in a dimly lit room with modern art on the wall.",
        "public_id": "019e89a7-abc9-70ad-8f18-d6352b30da1b",
        "storage_key": "property/5757666374713344/019e89a7-abc9-70ad-8f18-d6352b30da1b.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and rejuvenate in our state-of-the-art tanning bed, available for resident use.",
      "link": "",
      "alt_text": "Tanning bed in a dimly lit room with modern art on the wall.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_72e2a488-1fd8-4d1a-af58-545b1076557b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019e89a7-7efb-76d1-8a61-34eba1154029.webp",
      "image_media": {
        "alt_text": "Clubhouse living area with a large TV on a marble accent wall, leather sofa, and coffee table.",
        "public_id": "019e89a7-7efb-76d1-8a61-34eba1154029",
        "storage_key": "property/5757666374713344/019e89a7-7efb-76d1-8a61-34eba1154029.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish clubhouse living area, featuring a large entertainment TV and comfortable seating for socializing.",
      "link": "",
      "alt_text": "Clubhouse living area with a large TV on a marble accent wall, leather sofa, and coffee table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_4b6c25b2-3b6e-49d1-b679-d1bb3a8fdb87",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019e89a7-7f69-772b-b0b3-95d5aacbd285.webp",
      "image_media": {
        "alt_text": "Bedroom with a large bed, ceiling fan, and artwork.",
        "public_id": "019e89a7-7f69-772b-b0b3-95d5aacbd285",
        "storage_key": "property/5757666374713344/019e89a7-7f69-772b-b0b3-95d5aacbd285.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable bed, modern ceiling fan, and striking abstract artwork on the wall.",
      "link": "",
      "alt_text": "Bedroom with a large bed, ceiling fan, and artwork.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_60e2651f-5672-4f3c-bc55-8689b11e035f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019e89a7-7fbe-718c-b9a2-fc9747481d13.webp",
      "image_media": {
        "alt_text": "Business center with computers and workstations.",
        "public_id": "019e89a7-7fbe-718c-b9a2-fc9747481d13",
        "storage_key": "property/5757666374713344/019e89a7-7fbe-718c-b9a2-fc9747481d13.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Utilize our convenient business center, equipped with computers and workstations, to stay connected and productive during your stay.",
      "link": "",
      "alt_text": "Business center with computers and workstations.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_cd39ea0c-ff76-4ff2-8ede-9fb2b867eddf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019e89a7-7ea1-752c-ab19-45af598774f2.webp",
      "image_media": {
        "alt_text": "Private balcony with seating area and view of the street.",
        "public_id": "019e89a7-7ea1-752c-ab19-45af598774f2",
        "storage_key": "property/5757666374713344/019e89a7-7ea1-752c-ab19-45af598774f2.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy your morning coffee or evening unwind on this private balcony, complete with comfortable seating.",
      "link": "",
      "alt_text": "Private balcony with seating area and view of the street.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_cfba47f5-20ff-4959-9216-7f7da42d2409",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019e89a7-7e30-762f-bd96-87a4d5bb5bd2.webp",
      "image_media": {
        "alt_text": "Outdoor covered patio with fireplace, seating, and TV.",
        "public_id": "019e89a7-7e30-762f-bd96-87a4d5bb5bd2",
        "storage_key": "property/5757666374713344/019e89a7-7e30-762f-bd96-87a4d5bb5bd2.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind on the covered patio, complete with a cozy fireplace, comfortable seating, and a large television.",
      "link": "",
      "alt_text": "Outdoor covered patio with fireplace, seating, and TV.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_f5350744-27df-4aa4-88e4-3670ca3b718a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019e89a7-7f16-7259-b0dc-b12f3e0625ab.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool and lounge area at sunset.",
        "public_id": "019e89a7-7f16-7259-b0dc-b12f3e0625ab",
        "storage_key": "property/5757666374713344/019e89a7-7f16-7259-b0dc-b12f3e0625ab.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy the resort-style swimming pool and lounge area at sunset, perfect for relaxing and unwinding after a long day.",
      "link": "",
      "alt_text": "Resort-style swimming pool and lounge area at sunset.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_32e04818-6b67-470a-ae73-fb216aed075d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019e89a7-7f01-768f-a031-05d930c15b5a.webp",
      "image_media": {
        "alt_text": "Outdoor seating area with tables and umbrellas next to a swimming pool and apartment buildings.",
        "public_id": "019e89a7-7f01-768f-a031-05d930c15b5a",
        "storage_key": "property/5757666374713344/019e89a7-7f01-768f-a031-05d930c15b5a.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and enjoy the sunshine by our resort-style swimming pool, complete with comfortable seating and shaded areas for a perfect day outdoors.",
      "link": "",
      "alt_text": "Outdoor seating area with tables and umbrellas next to a swimming pool and apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_324ae722-4147-4b42-ad8e-be2c8cf27e13",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019e89a7-7e9d-75ff-a210-cad995b692cd.webp",
      "image_media": {
        "alt_text": "Modern living room and kitchen area with island and bar stools.",
        "public_id": "019e89a7-7e9d-75ff-a210-cad995b692cd",
        "storage_key": "property/5757666374713344/019e89a7-7e9d-75ff-a210-cad995b692cd.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Experience the spacious and stylish open-concept living area, featuring a modern kitchen with an island and comfortable seating.",
      "link": "",
      "alt_text": "Modern living room and kitchen area with island and bar stools.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_6aba6ccd-142d-4c29-a602-f013d44cc758",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019e89a7-75cc-75fc-b260-2d2d69c42096.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, purple bedding, and gold accents.",
        "public_id": "019e89a7-75cc-75fc-b260-2d2d69c42096",
        "storage_key": "property/5757666374713344/019e89a7-75cc-75fc-b260-2d2d69c42096.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Cozy bedroom featuring a queen-size bed with plush purple bedding and decorative throw pillows, complemented by stylish gold accents and a ceiling fan.",
      "link": "",
      "alt_text": "Bedroom with a queen-size bed, purple bedding, and gold accents.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_0e922e26-e4a0-4eb7-8006-fbc19910c0e5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019e89a7-7551-71db-8ed4-e3f9bed3b819.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, gray cabinets, and a large island with pendant lighting.",
        "public_id": "019e89a7-7551-71db-8ed4-e3f9bed3b819",
        "storage_key": "property/5757666374713344/019e89a7-7551-71db-8ed4-e3f9bed3b819.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Step into this beautifully appointed kitchen, featuring sleek gray cabinetry, stainless steel appliances, and a spacious island perfect for cooking and entertaining.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances, gray cabinets, and a large island with pendant lighting.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "ec_6576d14a944ad2460125208d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "source": "generator",
      "poi_name": "Kababchi Grill",
      "poi_type": "Restaurants",
      "poi_address": "5500 Babcock Rd Ste. 102, San Antonio, TX 78240, USA",
      "poi_short_description": "Airy, low-key outlet in a strip-mall offering Mediterranean fare such as charcoal grilled meats.",
      "poi_long_description": "Airy, low-key outlet in a strip-mall offering Mediterranean fare such as charcoal grilled meats.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f14fe-0e16-74ec-8837-138ea0dff85b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fe-0e16-74ec-8837-138ea0dff85b",
        "storage_key": "property/5757666374713344/019f14fe-0e16-74ec-8837-138ea0dff85b.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "http://kababchigrill.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8685288655476650596&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kababchi-grill",
      "poi_latitude": "29.5168602",
      "poi_longitude": "-98.5977506",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 210-960-9999",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f14fb-e08d-7048-b58a-54a2aa42ad2f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fb-e08d-7048-b58a-54a2aa42ad2f",
        "storage_key": "property/5757666374713344/019f14fb-e08d-7048-b58a-54a2aa42ad2f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_aKsz2ZnXIYRZHJq-QNYiHg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mediterranean_restaurant"
    },
    {
      "id": "ec_27187ea8813ec02910b6a89f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "source": "generator",
      "poi_name": "Shisha Cafe",
      "poi_type": "Restaurants",
      "poi_address": "5500 Babcock Rd #101, San Antonio, TX 78240, USA",
      "poi_short_description": "Informal Mediterranean cafe & hookah bar with falafel, kebabs, gyros & an array of tobacco flavors.",
      "poi_long_description": "Informal Mediterranean cafe & hookah bar with falafel, kebabs, gyros & an array of tobacco flavors.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f14fe-0e70-772b-a0d7-42c6799d9e62.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fe-0e70-772b-a0d7-42c6799d9e62",
        "storage_key": "property/5757666374713344/019f14fe-0e70-772b-a0d7-42c6799d9e62.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "http://shishacafesa.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16392614693749501050&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "shisha-cafe",
      "poi_latitude": "29.5167919",
      "poi_longitude": "-98.5976644",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 210-694-4800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f14fb-e0ee-76ca-a881-f4e43cbd8c14.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fb-e0ee-76ca-a881-f4e43cbd8c14",
        "storage_key": "property/5757666374713344/019f14fb-e0ee-76ca-a881-f4e43cbd8c14.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJRZUT32ZnXIYReqzJUDZEfuM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hookah_bar"
    },
    {
      "id": "ec_88aa79bc39004ee1934907c5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "source": "generator",
      "poi_name": "TULSI PURE VEG INDIAN CUISINE",
      "poi_type": "Restaurants",
      "poi_address": "5500 Babcock Rd Ste 106, San Antonio, TX 78240, USA",
      "poi_short_description": "Informal diner featuring Indian dishes, vegetarian fare and a buffet during lunch.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f14fe-14b4-7396-81c1-0eeeee025617.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fe-14b4-7396-81c1-0eeeee025617",
        "storage_key": "property/5757666374713344/019f14fe-14b4-7396-81c1-0eeeee025617.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=4205108622996336382&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tulsi-pure-veg-indian-cuisine",
      "poi_latitude": "29.5171517",
      "poi_longitude": "-98.59791690000002",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 726-222-9995",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f14fb-e08d-7048-b58a-54a2aa42ad2f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fb-e08d-7048-b58a-54a2aa42ad2f",
        "storage_key": "property/5757666374713344/019f14fb-e08d-7048-b58a-54a2aa42ad2f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5x5yCHhnXIYR_u6gUwOMWzo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "north_indian_restaurant"
    },
    {
      "id": "ec_e00117e3cd9905aab6bdecbf",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "source": "generator",
      "poi_name": "The Baked Bird",
      "poi_type": "Restaurants",
      "poi_address": "5822 Babcock Rd Ste 106, San Antonio, TX 78240, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f14fe-111c-729b-a5ac-8b5c05f9104c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fe-111c-729b-a5ac-8b5c05f9104c",
        "storage_key": "property/5757666374713344/019f14fe-111c-729b-a5ac-8b5c05f9104c.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.thebakedbirdsa.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6089662170237321293&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-baked-bird",
      "poi_latitude": "29.5241306",
      "poi_longitude": "-98.6010801",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 210-957-1125",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f14fb-e08d-7048-b58a-54a2aa42ad2f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fb-e08d-7048-b58a-54a2aa42ad2f",
        "storage_key": "property/5757666374713344/019f14fb-e08d-7048-b58a-54a2aa42ad2f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJxxVPEaSLXIYRTUAhu3rTglQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_c881828dc7a11c0d80679931",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "source": "generator",
      "poi_name": "Mi Guitarra Bar and Grill",
      "poi_type": "Restaurants",
      "poi_address": "5527 Babcock Rd, San Antonio, TX 78240, USA",
      "poi_short_description": "Homey establishment dishing up a selection of Mexican classics in a festive atmosphere.",
      "poi_long_description": "Homey establishment dishing up a selection of Mexican classics in a festive atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f14fe-0e6d-735e-a859-d9dc81a4798c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fe-0e6d-735e-a859-d9dc81a4798c",
        "storage_key": "property/5757666374713344/019f14fe-0e6d-735e-a859-d9dc81a4798c.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.miguitarragrill.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14136850999643240258&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mi-guitarra-bar-and-grill",
      "poi_latitude": "29.5192046",
      "poi_longitude": "-98.5960524",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 726-444-0055",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f14fb-e08d-7048-b58a-54a2aa42ad2f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fb-e08d-7048-b58a-54a2aa42ad2f",
        "storage_key": "property/5757666374713344/019f14fb-e08d-7048-b58a-54a2aa42ad2f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJcz5o7YxnXIYRQndcfBUvMMQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "ec_f9694e7ba5abcdf9ac762aca",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "source": "generator",
      "poi_name": "Berni Vietnamese Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "8742 Wurzbach Rd, San Antonio, TX 78240, USA",
      "poi_short_description": "Unassuming strip-mall Vietnamese restaurant serving pho, banh mi, rice dishes & more.",
      "poi_long_description": "Unassuming strip-mall Vietnamese restaurant serving pho, banh mi, rice dishes & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f14fe-0ec7-769a-9854-c1cf6e47fea9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fe-0ec7-769a-9854-c1cf6e47fea9",
        "storage_key": "property/5757666374713344/019f14fe-0ec7-769a-9854-c1cf6e47fea9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.facebook.com/Berni-Vietnamese-Restaurant-948608451871869/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3819150383141970362&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "berni-vietnamese-restaurant",
      "poi_latitude": "29.5240622",
      "poi_longitude": "-98.5687967",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 210-588-9079",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f14fb-e08d-7048-b58a-54a2aa42ad2f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fb-e08d-7048-b58a-54a2aa42ad2f",
        "storage_key": "property/5757666374713344/019f14fb-e08d-7048-b58a-54a2aa42ad2f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJv45JeLJgXIYRumH56glZADU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "vietnamese_restaurant"
    },
    {
      "id": "ec_27699b7c2f0a37d9c0e69f9d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "source": "generator",
      "poi_name": "Tommy's Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "8823 Wurzbach Rd, San Antonio, TX 78240, USA",
      "poi_short_description": "Easygoing fixture cooking up familiar Mexican plates with housemade tortillas.",
      "poi_long_description": "Easygoing fixture cooking up familiar Mexican plates with housemade tortillas.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f14fe-0dd0-7003-91d4-7485a864458a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fe-0dd0-7003-91d4-7485a864458a",
        "storage_key": "property/5757666374713344/019f14fe-0dd0-7003-91d4-7485a864458a.webp",
        "width": 1280,
        "height": 606
      },
      "poi_business_url": "http://mytommys.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14629519821366578851&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tommys-restaurant",
      "poi_latitude": "29.5250812",
      "poi_longitude": "-98.5686635",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 210-558-9777",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f14fb-e08d-7048-b58a-54a2aa42ad2f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fb-e08d-7048-b58a-54a2aa42ad2f",
        "storage_key": "property/5757666374713344/019f14fb-e08d-7048-b58a-54a2aa42ad2f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJC4G0aLJgXIYRo04XW8R-Bss",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "tex_mex_restaurant"
    },
    {
      "id": "ec_618c77b08977c1fbf2f48097",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "source": "generator",
      "poi_name": "Lee's Garden Chinese Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "7271 Wurzbach Rd #100, San Antonio, TX 78240, USA",
      "poi_short_description": "No-frills Chinese eatery that offers standard fare, including lo mein & egg foo young.",
      "poi_long_description": "No-frills Chinese eatery that offers standard fare, including lo mein & egg foo young.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f14fe-11da-7719-ad95-5b72f3e0253d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fe-11da-7719-ad95-5b72f3e0253d",
        "storage_key": "property/5757666374713344/019f14fe-11da-7719-ad95-5b72f3e0253d.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://pos.chowbus.com/online-ordering/store/Lee-s-Garden/23101",
      "poi_directions_map_url": "https://maps.google.com/?cid=11119894868141322034&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lees-garden-chinese-restaurant",
      "poi_latitude": "29.5035187",
      "poi_longitude": "-98.5853152",
      "poi_miles_from_property": "3.0 mi",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 210-692-9800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f14fb-e08d-7048-b58a-54a2aa42ad2f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fb-e08d-7048-b58a-54a2aa42ad2f",
        "storage_key": "property/5757666374713344/019f14fb-e08d-7048-b58a-54a2aa42ad2f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJzeBK4PBdXIYRMq9Ag3fNUZo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chinese_restaurant"
    },
    {
      "id": "ec_2831ae0baf5be66bef7564d4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "source": "generator",
      "poi_name": "Zaatar Lebanese Grill",
      "poi_type": "Restaurants",
      "poi_address": "9323 Wurzbach Rd, San Antonio, TX 78240, USA",
      "poi_short_description": "Lebanese restaurant known for its casual atmosphere and friendly staff.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f14fe-1515-7022-aeb6-d8d51f1c52e2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fe-1515-7022-aeb6-d8d51f1c52e2",
        "storage_key": "property/5757666374713344/019f14fe-1515-7022-aeb6-d8d51f1c52e2.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://gozaatar.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6392213113335803986&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "zaatar-lebanese-grill",
      "poi_latitude": "29.5291867",
      "poi_longitude": "-98.5645615",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 210-475-3699",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f14fb-e08d-7048-b58a-54a2aa42ad2f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fb-e08d-7048-b58a-54a2aa42ad2f",
        "storage_key": "property/5757666374713344/019f14fb-e08d-7048-b58a-54a2aa42ad2f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJEx6RcCBhXIYRUnD5jPWztVg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "lebanese_restaurant"
    },
    {
      "id": "ec_dd5caecfe20da8f11c3b70f1",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "source": "generator",
      "poi_name": "Pasha Mediterranean Grill",
      "poi_type": "Restaurants",
      "poi_address": "9339 Wurzbach Rd, San Antonio, TX 78240, USA",
      "poi_short_description": "Popular spot serving Eastern Mediterranean fare (gyros, kebabs, falafel & more) in a casual setting.",
      "poi_long_description": "Popular spot serving Eastern Mediterranean fare (gyros, kebabs, falafel & more) in a casual setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f14fe-106f-70e8-8942-ef696c8b7eb6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fe-106f-70e8-8942-ef696c8b7eb6",
        "storage_key": "property/5757666374713344/019f14fe-106f-70e8-8942-ef696c8b7eb6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://gopasha.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6679348126241967315&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pasha-mediterranean-grill",
      "poi_latitude": "29.5295565",
      "poi_longitude": "-98.5640792",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 210-561-5858",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f14fb-e08d-7048-b58a-54a2aa42ad2f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fb-e08d-7048-b58a-54a2aa42ad2f",
        "storage_key": "property/5757666374713344/019f14fb-e08d-7048-b58a-54a2aa42ad2f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJi2iRK7FgXIYR08zSa7vPsVw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mediterranean_restaurant"
    },
    {
      "id": "ec_32fe3947355aaaa72635cff1",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "source": "generator",
      "poi_name": "Sichuan House",
      "poi_type": "Restaurants",
      "poi_address": "3505 Wurzbach Rd #102, San Antonio, TX 78238, USA",
      "poi_short_description": "Humble eatery featuring Sichuan tapas, hot pots & mains such as pork belly & Kung Pao shrimp.",
      "poi_long_description": "Humble eatery featuring Sichuan tapas, hot pots & mains such as pork belly & Kung Pao shrimp.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f14fe-17b4-764b-86f2-27eac6c898a0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fe-17b4-764b-86f2-27eac6c898a0",
        "storage_key": "property/5757666374713344/019f14fe-17b4-764b-86f2-27eac6c898a0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.sichuaneats.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15050004160224051769&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sichuan-house",
      "poi_latitude": "29.47170659999999",
      "poi_longitude": "-98.6237126",
      "poi_miles_from_property": "6.3 mi",
      "poi_walking_minutes": "2 hours 19 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 210-509-9999",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f14fb-e08d-7048-b58a-54a2aa42ad2f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fb-e08d-7048-b58a-54a2aa42ad2f",
        "storage_key": "property/5757666374713344/019f14fb-e08d-7048-b58a-54a2aa42ad2f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJM4fcswVdXIYROUJOngtb3NA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chinese_restaurant"
    },
    {
      "id": "ec_449987cc8c748fbd766e69da",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "source": "generator",
      "poi_name": "Selda Mediterranean Kitchen & Bar - San Antonio, TX",
      "poi_type": "Restaurants",
      "poi_address": "9955 I-10, San Antonio, TX 78230, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f14fe-177a-761b-9f1d-489d5f5eb0aa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fe-177a-761b-9f1d-489d5f5eb0aa",
        "storage_key": "property/5757666374713344/019f14fe-177a-761b-9f1d-489d5f5eb0aa.webp",
        "width": 1060,
        "height": 1280
      },
      "poi_business_url": "https://seldarestaurant.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2051342949319924799&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "selda-mediterranean-kitchen--bar---san-antonio-tx",
      "poi_latitude": "29.53578229999999",
      "poi_longitude": "-98.5657125",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 210-236-5230",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f14fb-e08d-7048-b58a-54a2aa42ad2f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fb-e08d-7048-b58a-54a2aa42ad2f",
        "storage_key": "property/5757666374713344/019f14fb-e08d-7048-b58a-54a2aa42ad2f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJWYTwfBhhXIYRP1y3PovVdxw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "turkish_restaurant"
    },
    {
      "id": "ec_c80414b8f678bfc05dfd70fb",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "source": "generator",
      "poi_name": "Taqueria La Terraza at Alamo Ranch",
      "poi_type": "Restaurants",
      "poi_address": "11840 Alamo Ranch Pkwy Ste 40, San Antonio, TX 78253, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f14fe-1bb4-7399-82d6-20f1bd8eaa7f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fe-1bb4-7399-82d6-20f1bd8eaa7f",
        "storage_key": "property/5757666374713344/019f14fe-1bb4-7399-82d6-20f1bd8eaa7f.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=12652612389881287858&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "taqueria-la-terraza-at-alamo-ranch",
      "poi_latitude": "29.4850073",
      "poi_longitude": "-98.72601",
      "poi_miles_from_property": "12.3 mi",
      "poi_walking_minutes": "4 hours 34 mins",
      "poi_biking_minutes": "1 hour 19 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 210-352-5208",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f14fb-e08d-7048-b58a-54a2aa42ad2f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fb-e08d-7048-b58a-54a2aa42ad2f",
        "storage_key": "property/5757666374713344/019f14fb-e08d-7048-b58a-54a2aa42ad2f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJreG8e6dDXIYRspSUo-4bl68",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_12269dfe7ff0a500ed649461",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "source": "generator",
      "poi_name": "Archies Coffee Lounge",
      "poi_type": "Restaurants",
      "poi_address": "9630 Huebner Rd Ste 101, San Antonio, TX 78240, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f14fe-1897-7218-9aff-bde4ba9f31f8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fe-1897-7218-9aff-bde4ba9f31f8",
        "storage_key": "property/5757666374713344/019f14fe-1897-7218-9aff-bde4ba9f31f8.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://archiescoffee.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13839923673842829976&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "archies-coffee-lounge",
      "poi_latitude": "29.5320819",
      "poi_longitude": "-98.5907849",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 210-314-7723",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f14fe-5eb2-72a8-95df-dcf03d4cff53.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fe-5eb2-72a8-95df-dcf03d4cff53",
        "storage_key": "property/5757666374713344/019f14fe-5eb2-72a8-95df-dcf03d4cff53.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJTbdCBmJnXIYRmMrrGUFJEcA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "ec_5a30cc10cb5a18ab91b95f95",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "source": "generator",
      "poi_name": "The Magnolia Pancake Haus",
      "poi_type": "Restaurants",
      "poi_address": "10333 Huebner Rd, San Antonio, TX 78240, USA",
      "poi_short_description": "Popular mainstay known for its ample breakfast options, plus a lunch menu served in homey surrounds.",
      "poi_long_description": "Popular mainstay known for its ample breakfast options, plus a lunch menu served in homey surrounds.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f14fe-194b-760c-9545-b9ebc657554b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fe-194b-760c-9545-b9ebc657554b",
        "storage_key": "property/5757666374713344/019f14fe-194b-760c-9545-b9ebc657554b.webp",
        "width": 800,
        "height": 529
      },
      "poi_business_url": "http://www.magnoliapancakehaus.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14524265434804272114&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-magnolia-pancake-haus",
      "poi_latitude": "29.5399915",
      "poi_longitude": "-98.5848659",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 254-269-5347",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f14fb-e08d-7048-b58a-54a2aa42ad2f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fb-e08d-7048-b58a-54a2aa42ad2f",
        "storage_key": "property/5757666374713344/019f14fb-e08d-7048-b58a-54a2aa42ad2f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJpZmeiTlnXIYR8jv-yHWOkMk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "breakfast_restaurant"
    },
    {
      "id": "ec_6fe97e7f1129ad2724af22d5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "source": "generator",
      "poi_name": "Circle K",
      "poi_type": "Shopping & Retail",
      "poi_address": "10219 Huebner Rd, San Antonio, TX 78240, USA",
      "poi_short_description": "Convenience store and gas station offering snacks, coffee, and drinks, including Polar Pop and Froster options.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f14fe-1c12-76c8-8cee-01073fb473b8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fe-1c12-76c8-8cee-01073fb473b8",
        "storage_key": "property/5757666374713344/019f14fe-1c12-76c8-8cee-01073fb473b8.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.circlek.com/store-locator/US/san-antonio/10219-huebner-rd/2741084?utm_source=google&utm_medium=local&utm_campaign=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=1797960046385649079&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "circle-k",
      "poi_latitude": "29.5385446",
      "poi_longitude": "-98.5859601",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 210-694-4540",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f14fe-5eeb-754e-8931-36e64081e4e5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fe-5eeb-754e-8931-36e64081e4e5",
        "storage_key": "property/5757666374713344/019f14fe-5eeb-754e-8931-36e64081e4e5.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJi8NzpjlnXIYRt1Up3SKj8xg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "ec_b83646a8a74fb0aabde2a99f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "source": "generator",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Shopping & Retail",
      "poi_address": "8602 Huebner Rd, San Antonio, TX 78240, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f14fe-1baf-7740-aedd-c06e1da136ee.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fe-1baf-7740-aedd-c06e1da136ee",
        "storage_key": "property/5757666374713344/019f14fe-1baf-7740-aedd-c06e1da136ee.webp",
        "width": 1100,
        "height": 743
      },
      "poi_business_url": "https://www.cvs.com/store-locator/san-antonio-tx-pharmacies/8602-huebner-rd-san-antonio-tx-78240/storeid=8389?WT.mc_id=LS_GOOGLE_RX_8389",
      "poi_directions_map_url": "https://maps.google.com/?cid=14445868744845257167&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "29.5188927",
      "poi_longitude": "-98.603617",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 210-691-0174",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f14fe-5ed0-73d8-9924-622cdb50c635.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fe-5ed0-73d8-9924-622cdb50c635",
        "storage_key": "property/5757666374713344/019f14fe-5ed0-73d8-9924-622cdb50c635.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJt6KGH2VnXIYRz2lrABYJesg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_86d825d15c46fcb2dfa30890",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "source": "generator",
      "poi_name": "H-E-B",
      "poi_type": "Shopping & Retail",
      "poi_address": "8503 NW Military Hwy, San Antonio, TX 78231, USA",
      "poi_short_description": "Branch of a supermarket chain offering groceries, beer & wine, plus a deli, pharmacy & florist.",
      "poi_long_description": "Branch of a supermarket chain offering groceries, beer & wine, plus a deli, pharmacy & florist.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f14fe-1ba7-70ce-9f63-ebd78f2eba48.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fe-1ba7-70ce-9f63-ebd78f2eba48",
        "storage_key": "property/5757666374713344/019f14fe-1ba7-70ce-9f63-ebd78f2eba48.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.heb.com/heb-store/tx/san-antonio/alon-market-h-e-b-102?utm_source=google&utm_medium=organic&utm_campaign=gmb_stores",
      "poi_directions_map_url": "https://maps.google.com/?cid=586250807360616769&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "h-e-b",
      "poi_latitude": "29.552819",
      "poi_longitude": "-98.534243",
      "poi_miles_from_property": "4.8 mi",
      "poi_walking_minutes": "1 hour 48 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 210-479-4300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f14fb-e051-7557-979e-67ce3e44b884.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fb-e051-7557-979e-67ce3e44b884",
        "storage_key": "property/5757666374713344/019f14fb-e051-7557-979e-67ce3e44b884.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJafb0jftgXIYRQfkD0gDIIgg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_8c6694163a80d9141228d17f",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "source": "generator",
      "poi_name": "Sam's Club",
      "poi_type": "Shopping & Retail",
      "poi_address": "5055 Northwest Loop 410, San Antonio, TX 78229, USA",
      "poi_short_description": "Membership-only warehouse chain selling a variety of bulk grocery items, electronics & home goods.",
      "poi_long_description": "Membership-only warehouse chain selling a variety of bulk grocery items, electronics & home goods.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f14fe-1e23-7712-9bae-fb9e1c5a0aa4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fe-1e23-7712-9bae-fb9e1c5a0aa4",
        "storage_key": "property/5757666374713344/019f14fe-1e23-7712-9bae-fb9e1c5a0aa4.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.samsclub.com/club/8227-san-antonio-tx",
      "poi_directions_map_url": "https://maps.google.com/?cid=6084882110566361120&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sams-club",
      "poi_latitude": "29.4896624",
      "poi_longitude": "-98.5886898",
      "poi_miles_from_property": "4.7 mi",
      "poi_walking_minutes": "1 hour 45 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 210-680-9425",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f14fb-e04f-7029-8543-55d5aea82efe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fb-e04f-7029-8543-55d5aea82efe",
        "storage_key": "property/5757666374713344/019f14fb-e04f-7029-8543-55d5aea82efe.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJuypVHupdXIYRIOhvXArYcVQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "ec_6a51705d046b87089ebb0755",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "source": "generator",
      "poi_name": "Target",
      "poi_type": "Shopping & Retail",
      "poi_address": "746 Northwest Loop 410, San Antonio, TX 78216, USA",
      "poi_short_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_long_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f14fe-1edb-7085-bbdf-52e9f71e83fa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fe-1edb-7085-bbdf-52e9f71e83fa",
        "storage_key": "property/5757666374713344/019f14fe-1edb-7085-bbdf-52e9f71e83fa.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.target.com/sl/park-north/2467",
      "poi_directions_map_url": "https://maps.google.com/?cid=12301680051112071296&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "target",
      "poi_latitude": "29.5165568",
      "poi_longitude": "-98.5051094",
      "poi_miles_from_property": "7.3 mi",
      "poi_walking_minutes": "2 hours 42 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 210-424-2301",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f14fb-e04f-7029-8543-55d5aea82efe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fb-e04f-7029-8543-55d5aea82efe",
        "storage_key": "property/5757666374713344/019f14fb-e04f-7029-8543-55d5aea82efe.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJGwH3owpgXIYRgFALU9RYuKo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "ec_c825ff0540430c2ef3e11a3a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "source": "generator",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "918 Bandera Rd, San Antonio, TX 78228, USA",
      "poi_short_description": "Department store chain selling a variety of items, from clothing and electronics to groceries and furniture.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f14fe-2122-70f4-aa11-b1c54d9f9d2d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fe-2122-70f4-aa11-b1c54d9f9d2d",
        "storage_key": "property/5757666374713344/019f14fe-2122-70f4-aa11-b1c54d9f9d2d.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/3058-san-antonio-tx/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=15946730221243049944&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "29.4586065",
      "poi_longitude": "-98.5536167",
      "poi_miles_from_property": "6.9 mi",
      "poi_walking_minutes": "2 hours 33 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 210-536-0576",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f14fb-e04f-7029-8543-55d5aea82efe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fb-e04f-7029-8543-55d5aea82efe",
        "storage_key": "property/5757666374713344/019f14fb-e04f-7029-8543-55d5aea82efe.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJMeIU1Y1eXIYR2KctlqUqTt0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "ec_86747211adbca161d2079b3c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "source": "generator",
      "poi_name": "Dollar Tree",
      "poi_type": "Shopping & Retail",
      "poi_address": "6065 Northwest Loop 410 Ste 116, San Antonio, TX 78238, USA",
      "poi_short_description": "Chain offering a mix of household items, beauty products, food & more at discount prices.",
      "poi_long_description": "Chain offering a mix of household items, beauty products, food & more at discount prices.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f14fe-1fc7-7381-abe5-6d1ee2da71b8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fe-1fc7-7381-abe5-6d1ee2da71b8",
        "storage_key": "property/5757666374713344/019f14fe-1fc7-7381-abe5-6d1ee2da71b8.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://locations.dollartree.com/tx/san-antonio/6065-nw-loop-410-116?utm_source=google&utm_medium=organic&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=478696749586393813&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dollar-tree",
      "poi_latitude": "29.4750227",
      "poi_longitude": "-98.6129652",
      "poi_miles_from_property": "5.8 mi",
      "poi_walking_minutes": "2 hours 10 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 726-217-7420",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f14fb-e04f-7029-8543-55d5aea82efe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fb-e04f-7029-8543-55d5aea82efe",
        "storage_key": "property/5757666374713344/019f14fb-e04f-7029-8543-55d5aea82efe.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJIfq6Y6hdXIYR1So7UiispAY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "discount_store"
    },
    {
      "id": "ec_3121dd60b0fc348d479a3b2a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "source": "generator",
      "poi_name": "Ingram Park Mall",
      "poi_type": "Shopping & Retail",
      "poi_address": "6301 Northwest Loop 410, San Antonio, TX 78238, USA",
      "poi_short_description": "Classic mall featuring 150 stores, including major fashion chains, department stores & a food court.",
      "poi_long_description": "Classic mall featuring 150 stores, including major fashion chains, department stores & a food court.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f14fb-6b73-702a-adf2-336377e2b30f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fb-6b73-702a-adf2-336377e2b30f",
        "storage_key": "property/5757666374713344/019f14fb-6b73-702a-adf2-336377e2b30f.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.ingram-park-mall.com/?utm_source=google-business-profile&utm_medium=organic&utm_campaign=business-listing&utm_id=85503&y_source=1_OTgyMzAzOTctNzE1LWxvY2F0aW9uLndlYnNpdGU=",
      "poi_directions_map_url": "https://maps.google.com/?cid=9962965456025266356&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ingram-park-mall",
      "poi_latitude": "29.4691034",
      "poi_longitude": "-98.6210028",
      "poi_miles_from_property": "6.4 mi",
      "poi_walking_minutes": "2 hours 23 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 210-523-1228",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f14fb-e04f-7029-8543-55d5aea82efe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fb-e04f-7029-8543-55d5aea82efe",
        "storage_key": "property/5757666374713344/019f14fb-e04f-7029-8543-55d5aea82efe.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJL6TgsAZdXIYRtKjf00uQQ4o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "ec_b8c68dc87fd7cffe1428b294",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "source": "generator",
      "poi_name": "Best Buy",
      "poi_type": "Shopping & Retail",
      "poi_address": "6001 Northwest Loop 410, San Antonio, TX 78238, USA",
      "poi_short_description": "Chain retailer with a large array of brand-name electronics, computers, appliances & more.",
      "poi_long_description": "Chain retailer with a large array of brand-name electronics, computers, appliances & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f14fe-2131-7163-a839-b21bea0b9dd1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fe-2131-7163-a839-b21bea0b9dd1",
        "storage_key": "property/5757666374713344/019f14fe-2131-7163-a839-b21bea0b9dd1.webp",
        "width": 1280,
        "height": 887
      },
      "poi_business_url": "https://stores.bestbuy.com/tx/san-antonio/6001-nw-loop-410-152.html/?ref=NS&loc=ns100",
      "poi_directions_map_url": "https://maps.google.com/?cid=16404434343803144499&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "best-buy",
      "poi_latitude": "29.476028",
      "poi_longitude": "-98.612114",
      "poi_miles_from_property": "5.7 mi",
      "poi_walking_minutes": "2 hours 8 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 210-509-5749",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f14fb-e04f-7029-8543-55d5aea82efe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fb-e04f-7029-8543-55d5aea82efe",
        "storage_key": "property/5757666374713344/019f14fb-e04f-7029-8543-55d5aea82efe.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJhW41pQZdXIYRM8maCx9CqOM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "electronics_store"
    },
    {
      "id": "ec_25684bc4477d8d9b59765ec5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "source": "generator",
      "poi_name": "Robert F. McDermott Elementary School",
      "poi_type": "Education",
      "poi_address": "5111 Usaa Blvd, San Antonio, TX 78240, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f14fe-2131-7163-a839-b517e5850d6c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fe-2131-7163-a839-b517e5850d6c",
        "storage_key": "property/5757666374713344/019f14fe-2131-7163-a839-b517e5850d6c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.nisd.net/mcdermott",
      "poi_directions_map_url": "https://maps.google.com/?cid=9531486944329900651&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "robert-f-mcdermott-elementary-school",
      "poi_latitude": "29.534554",
      "poi_longitude": "-98.5841907",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 210-397-5100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f14fb-e096-776e-8daa-830462c5fbe4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fb-e096-776e-8daa-830462c5fbe4",
        "storage_key": "property/5757666374713344/019f14fb-e096-776e-8daa-830462c5fbe4.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJjdCvcThnXIYRa6IOOuCkRoQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_adad6a4f53a8931a90b843f4",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "source": "generator",
      "poi_name": "Frances M. Rhodes Elementary School",
      "poi_type": "Education",
      "poi_address": "5714 N Knoll, San Antonio, TX 78240, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.nisd.net/rhodes",
      "poi_directions_map_url": "https://maps.google.com/?cid=4223592382511599027&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "frances-m-rhodes-elementary-school",
      "poi_latitude": "29.511704",
      "poi_longitude": "-98.600546",
      "poi_miles_from_property": "3.2 mi",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 210-397-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f14fb-e096-776e-8daa-830462c5fbe4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fb-e096-776e-8daa-830462c5fbe4",
        "storage_key": "property/5757666374713344/019f14fb-e096-776e-8daa-830462c5fbe4.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJob4ga2JnXIYRs02m8-Q2nTo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_190607edec4c6c02da024fd7",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "source": "generator",
      "poi_name": "Leon Valley Elementary School",
      "poi_type": "Education",
      "poi_address": "7111 Huebner Rd, San Antonio, TX 78240, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://nisd.net/leonvalley/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7438153816549038984&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "leon-valley-elementary-school",
      "poi_latitude": "29.5025963",
      "poi_longitude": "-98.6229928",
      "poi_miles_from_property": "4.1 mi",
      "poi_walking_minutes": "1 hour 30 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 210-397-4650",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f14fb-e096-776e-8daa-830462c5fbe4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fb-e096-776e-8daa-830462c5fbe4",
        "storage_key": "property/5757666374713344/019f14fb-e096-776e-8daa-830462c5fbe4.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ49X3WnldXIYRiBsftHyhOWc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_065fd27e7b438863d172e68b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "source": "generator",
      "poi_name": "Earl Rudder Middle School",
      "poi_type": "Education",
      "poi_address": "6558 Horn Blvd, San Antonio, TX 78240, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f14fe-2329-70e7-abb5-bc2dcc3e87e4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fe-2329-70e7-abb5-bc2dcc3e87e4",
        "storage_key": "property/5757666374713344/019f14fe-2329-70e7-abb5-bc2dcc3e87e4.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://nisd.net/rudder/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5188005513050754728&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "earl-rudder-middle-school",
      "poi_latitude": "29.53946299999999",
      "poi_longitude": "-98.61672",
      "poi_miles_from_property": "3.4 mi",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 210-397-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f14fb-e096-776e-8daa-830462c5fbe4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fb-e096-776e-8daa-830462c5fbe4",
        "storage_key": "property/5757666374713344/019f14fb-e096-776e-8daa-830462c5fbe4.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJSW8u4glnXIYRqI4o4oZ__0c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_820582fe8c0a84b4fc7693d1",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "source": "generator",
      "poi_name": "John Marshall High School",
      "poi_type": "Education",
      "poi_address": "8000 Lobo Ln, San Antonio, TX 78240, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f14fe-24c4-7058-ba79-ebfef750d609.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fe-24c4-7058-ba79-ebfef750d609",
        "storage_key": "property/5757666374713344/019f14fe-24c4-7058-ba79-ebfef750d609.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://nisd.net/marshall/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17320267335718771797&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "john-marshall-high-school",
      "poi_latitude": "29.513627",
      "poi_longitude": "-98.619869",
      "poi_miles_from_property": "3.6 mi",
      "poi_walking_minutes": "1 hour 21 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 210-397-7100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f14fb-e096-776e-8daa-830462c5fbe4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fb-e096-776e-8daa-830462c5fbe4",
        "storage_key": "property/5757666374713344/019f14fb-e096-776e-8daa-830462c5fbe4.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ87UJBYFnXIYRVZxRCGDzXfA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "ec_5f637f9e22b49414183878aa",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "source": "generator",
      "poi_name": "Bright Horizons",
      "poi_type": "Education",
      "poi_address": "4800 Usaa Blvd, San Antonio, TX 78240, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://brighthorizons.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10103233872979386771&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bright-horizons",
      "poi_latitude": "29.5360063",
      "poi_longitude": "-98.5787575",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 210-694-4121",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f14fb-e096-776e-8daa-830462c5fbe4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fb-e096-776e-8daa-830462c5fbe4",
        "storage_key": "property/5757666374713344/019f14fb-e096-776e-8daa-830462c5fbe4.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJv6ovFDZnXIYRk2Ghoa3lNYw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "ec_a7bcd14fea93beeb7a1ce02e",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "source": "generator",
      "poi_name": "The Precinct Academy & Daycare",
      "poi_type": "Education",
      "poi_address": "7500 Eckhert Rd #140, San Antonio, TX 78240, USA",
      "poi_short_description": "Family-owned daycare that requires appointments.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f14fe-25e0-7675-ac2a-88aaca3e928d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fe-25e0-7675-ac2a-88aaca3e928d",
        "storage_key": "property/5757666374713344/019f14fe-25e0-7675-ac2a-88aaca3e928d.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.precinctdaycare.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18214494670204069675&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-precinct-academy--daycare",
      "poi_latitude": "29.507547",
      "poi_longitude": "-98.627091",
      "poi_miles_from_property": "4.2 mi",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 210-272-0376",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f14fb-e096-776e-8daa-830462c5fbe4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fb-e096-776e-8daa-830462c5fbe4",
        "storage_key": "property/5757666374713344/019f14fb-e096-776e-8daa-830462c5fbe4.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJs6CptGJdXIYRK2fC5GXixvw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "ec_d5dd8aa3094d2653a1df17a9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "source": "generator",
      "poi_name": "Backyard Kids Learning Center",
      "poi_type": "Education",
      "poi_address": "7305 Huebner Rd #3124, San Antonio, TX 78240, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f14fe-244c-746a-9bb2-c9196fc8a311.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fe-244c-746a-9bb2-c9196fc8a311",
        "storage_key": "property/5757666374713344/019f14fe-244c-746a-9bb2-c9196fc8a311.webp",
        "width": 656,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=18010825672883281474&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "backyard-kids-learning-center",
      "poi_latitude": "29.5041802",
      "poi_longitude": "-98.6196906",
      "poi_miles_from_property": "3.8 mi",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 210-681-5030",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f14fb-e096-776e-8daa-830462c5fbe4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fb-e096-776e-8daa-830462c5fbe4",
        "storage_key": "property/5757666374713344/019f14fb-e096-776e-8daa-830462c5fbe4.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJPXqWxX5dXIYRQp6xJ4ZO8_k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "ec_86df443d240b3c1d7e88eab6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "source": "generator",
      "poi_name": "Northwest Vista College",
      "poi_type": "Education",
      "poi_address": "3535 N Ellison Dr, San Antonio, TX 78251, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f14fe-23f3-7025-9af5-87a443305648.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fe-23f3-7025-9af5-87a443305648",
        "storage_key": "property/5757666374713344/019f14fe-23f3-7025-9af5-87a443305648.webp",
        "width": 1137,
        "height": 640
      },
      "poi_business_url": "https://www.alamo.edu/nvc/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17417931226689792052&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "northwest-vista-college",
      "poi_latitude": "29.4716439",
      "poi_longitude": "-98.705443",
      "poi_miles_from_property": "11.0 mi",
      "poi_walking_minutes": "4 hours 6 mins",
      "poi_biking_minutes": "1 hour 13 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 210-486-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f14fb-e096-776e-8daa-830462c5fbe4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fb-e096-776e-8daa-830462c5fbe4",
        "storage_key": "property/5757666374713344/019f14fb-e096-776e-8daa-830462c5fbe4.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJO8IBBVpCXIYRNGgHoSrsuPE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_d66907f2f5ef5c297f05ee2d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "source": "generator",
      "poi_name": "The University of Texas at San Antonio",
      "poi_type": "Education",
      "poi_address": "Physical Education Building, 1 UTSA Circle, San Antonio, TX 78249, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f14fb-78ad-7219-97b7-1883d24179d4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fb-78ad-7219-97b7-1883d24179d4",
        "storage_key": "property/5757666374713344/019f14fb-78ad-7219-97b7-1883d24179d4.webp",
        "width": 1280,
        "height": 834
      },
      "poi_business_url": "https://www.utsa.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2658632929587635980&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-university-of-texas-at-san-antonio",
      "poi_latitude": "29.5830733",
      "poi_longitude": "-98.6198779",
      "poi_miles_from_property": "5.6 mi",
      "poi_walking_minutes": "2 hours 6 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 210-458-4011",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f14fb-e096-776e-8daa-830462c5fbe4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fb-e096-776e-8daa-830462c5fbe4",
        "storage_key": "property/5757666374713344/019f14fb-e096-776e-8daa-830462c5fbe4.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ3X9l1n1mXIYRDCc6PJBc5SQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_b3ca6d374a8a4ff88cb19d35",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "source": "generator",
      "poi_name": "Santikos Palladium",
      "poi_type": "Entertainment",
      "poi_address": "17703 W Interstate 10 Frontage Rd, San Antonio, TX 78257, USA",
      "poi_short_description": "Upscale movie theater with a full food & drink menu, plus table seating & wait service.",
      "poi_long_description": "Upscale movie theater with a full food & drink menu, plus table seating & wait service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f14fe-269a-736e-844c-759a7bf5df23.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fe-269a-736e-844c-759a7bf5df23",
        "storage_key": "property/5757666374713344/019f14fe-269a-736e-844c-759a7bf5df23.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.santikos.com/san-antonio/palladium/theater-info/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8534017591422902188&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "santikos-palladium",
      "poi_latitude": "29.6085339",
      "poi_longitude": "-98.5992852",
      "poi_miles_from_property": "6.6 mi",
      "poi_walking_minutes": "2 hours 29 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 877-691-0734",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f14fe-5eeb-754e-8931-31e4c394b00f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fe-5eeb-754e-8931-31e4c394b00f",
        "storage_key": "property/5757666374713344/019f14fe-5eeb-754e-8931-31e4c394b00f.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7ZDq_iNkXIYRrF-yw8jrbnY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "ec_c32ac5fe8f5cecef779495fe",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "source": "generator",
      "poi_name": "Six Flags Fiesta Texas",
      "poi_type": "Entertainment",
      "poi_address": "San Antonio, TX 78257, USA",
      "poi_short_description": "Part of an amusement park chain with roller coasters, rides, live shows, a water park, food & beer.",
      "poi_long_description": "Part of an amusement park chain with roller coasters, rides, live shows, a water park, food & beer.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f14fb-9792-71b4-af8f-b7b5a8c1308f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fb-9792-71b4-af8f-b7b5a8c1308f",
        "storage_key": "property/5757666374713344/019f14fb-9792-71b4-af8f-b7b5a8c1308f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.sixflags.com/fiestatexas?utm_source=googlebusinessprofile&utm_medium=organic&utm_campaign=Google+Business+Profile",
      "poi_directions_map_url": "https://maps.google.com/?cid=2548967654066146973&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "six-flags-fiesta-texas",
      "poi_latitude": "29.5993818",
      "poi_longitude": "-98.6088838",
      "poi_miles_from_property": "7.0 mi",
      "poi_walking_minutes": "2 hours 39 mins",
      "poi_biking_minutes": "52 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 210-697-5050",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f14fb-e0ee-76ca-a881-f4e43cbd8c14.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fb-e0ee-76ca-a881-f4e43cbd8c14",
        "storage_key": "property/5757666374713344/019f14fb-e0ee-76ca-a881-f4e43cbd8c14.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJN55XmxZlXIYRnc6SjJPAXyM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_center"
    },
    {
      "id": "ec_0c32490f4ca7a3968185d632",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "source": "generator",
      "poi_name": "The Shops at La Cantera",
      "poi_type": "Entertainment",
      "poi_address": "15900 La Cantera Pkwy Ste 6698, San Antonio, TX 78256, USA",
      "poi_short_description": "Upscale shopping center along an outdoor mall-style walkway with a wide variety of restaurants, shops and food options.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f14fb-82e8-7061-bd96-bf465cf059e2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fb-82e8-7061-bd96-bf465cf059e2",
        "storage_key": "property/5757666374713344/019f14fb-82e8-7061-bd96-bf465cf059e2.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.theshopsatlacantera.com/en.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=11016393100736632124&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-shops-at-la-cantera",
      "poi_latitude": "29.5922066",
      "poi_longitude": "-98.6153483",
      "poi_miles_from_property": "6.5 mi",
      "poi_walking_minutes": "2 hours 26 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 210-582-6255",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f14fb-e04f-7029-8543-55d5aea82efe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fb-e04f-7029-8543-55d5aea82efe",
        "storage_key": "property/5757666374713344/019f14fb-e04f-7029-8543-55d5aea82efe.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ4RQtcodmXIYRPJV4YygX4pg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "ec_dcca4d484f9bdff648ad7b49",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "source": "generator",
      "poi_name": "Cinemark San Antonio 16",
      "poi_type": "Entertainment",
      "poi_address": "The Summit, 5063 Northwest Loop 410 W, San Antonio, TX 78229, USA",
      "poi_short_description": "Chain of movie theaters, some with multiple screens, stadium seats & self-service ticketing kiosks.",
      "poi_long_description": "Chain of movie theaters, some with multiple screens, stadium seats & self-service ticketing kiosks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f14fe-2ae7-72ce-adfb-6a269c61e208.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fe-2ae7-72ce-adfb-6a269c61e208",
        "storage_key": "property/5757666374713344/019f14fe-2ae7-72ce-adfb-6a269c61e208.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cinemark.com/theatres/tx-san-antonio/cinemark-san-antonio-16?utm_medium=organic&utm_source=gmb&utm_campaign=local_listing_theater&utm_content=GMB_listing&y_source=1_MTc0OTMxMzYtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=1911946583388476699&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cinemark-san-antonio-16",
      "poi_latitude": "29.4893256",
      "poi_longitude": "-98.59074900000002",
      "poi_miles_from_property": "4.8 mi",
      "poi_walking_minutes": "1 hour 47 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 210-522-9660",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f14fe-5eeb-754e-8931-31e4c394b00f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fe-5eeb-754e-8931-31e4c394b00f",
        "storage_key": "property/5757666374713344/019f14fe-5eeb-754e-8931-31e4c394b00f.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJWamPOZxdXIYRG1VkpEmZiBo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "ec_0faeee936885868a29243013",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "source": "generator",
      "poi_name": "Alamo Quarry Market",
      "poi_type": "Entertainment",
      "poi_address": "255 E Basse Rd, San Antonio, TX 78209, USA",
      "poi_short_description": "Airy mall home to major apparel & homewares stores, eclectic eateries & a cinema amid a modern site.",
      "poi_long_description": "Airy mall home to major apparel & homewares stores, eclectic eateries & a cinema amid a modern site.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f14fe-2ed9-77ec-b06c-038d8ed941a7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fe-2ed9-77ec-b06c-038d8ed941a7",
        "storage_key": "property/5757666374713344/019f14fe-2ed9-77ec-b06c-038d8ed941a7.webp",
        "width": 1280,
        "height": 719
      },
      "poi_business_url": "http://quarrymarket.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4663225067816664189&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "alamo-quarry-market",
      "poi_latitude": "29.4962615",
      "poi_longitude": "-98.4799046",
      "poi_miles_from_property": "9.3 mi",
      "poi_walking_minutes": "3 hours 26 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 210-824-8885",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f14fb-e04f-7029-8543-55d5aea82efe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fb-e04f-7029-8543-55d5aea82efe",
        "storage_key": "property/5757666374713344/019f14fb-e04f-7029-8543-55d5aea82efe.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ7See-2D1XIYRfbzoCn4at0A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "ec_345b4eddeaca7b665a7da1d8",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "source": "generator",
      "poi_name": "The DoSeum",
      "poi_type": "Entertainment",
      "poi_address": "2800 Broadway, San Antonio, TX 78209, USA",
      "poi_short_description": "2-story museum promoting learning & discovery through interactive exhibits & creative programs.",
      "poi_long_description": "2-story museum promoting learning & discovery through interactive exhibits & creative programs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f14fe-2aa0-74a8-a2f8-f5957b5740df.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fe-2aa0-74a8-a2f8-f5957b5740df",
        "storage_key": "property/5757666374713344/019f14fe-2aa0-74a8-a2f8-f5957b5740df.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://thedoseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15763963794875614826&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-doseum",
      "poi_latitude": "29.4533152",
      "poi_longitude": "-98.4716971",
      "poi_miles_from_property": "10.4 mi",
      "poi_walking_minutes": "3 hours 52 mins",
      "poi_biking_minutes": "1 hour 0 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 210-212-4453",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f14fe-5eed-73ae-8db3-263dff6bc8ed.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fe-5eed-73ae-8db3-263dff6bc8ed",
        "storage_key": "property/5757666374713344/019f14fe-5eed-73ae-8db3-263dff6bc8ed.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJIVWnfJL1XIYRagau5YzZxNo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "ec_d5cdfc1864add77683ab4246",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "source": "generator",
      "poi_name": "Witte Museum",
      "poi_type": "Entertainment",
      "poi_address": "3801 Broadway, San Antonio, TX 78209, USA",
      "poi_short_description": "Touring & long-term exhibits about natural history, art & Texas heritage, plus a Science Treehouse.",
      "poi_long_description": "Touring & long-term exhibits about natural history, art & Texas heritage, plus a Science Treehouse.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f14fe-3188-7139-9f2a-c30c22686a39.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fe-3188-7139-9f2a-c30c22686a39",
        "storage_key": "property/5757666374713344/019f14fe-3188-7139-9f2a-c30c22686a39.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.wittemuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14696973662473378755&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "witte-museum",
      "poi_latitude": "29.46197799999999",
      "poi_longitude": "-98.4669496",
      "poi_miles_from_property": "10.4 mi",
      "poi_walking_minutes": "3 hours 52 mins",
      "poi_biking_minutes": "1 hour 3 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 210-357-1900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f14fe-5eed-73ae-8db3-263dff6bc8ed.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fe-5eed-73ae-8db3-263dff6bc8ed",
        "storage_key": "property/5757666374713344/019f14fe-5eed-73ae-8db3-263dff6bc8ed.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8SkZWZf1XIYRw1v_mK0j9ss",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "ec_171e7a8f0305e8d9bed5940d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "source": "generator",
      "poi_name": "San Antonio Zoo",
      "poi_type": "Entertainment",
      "poi_address": "3903 N St Mary's St, San Antonio, TX 78212, USA",
      "poi_short_description": "Sprawling zoo with 750 species (from alligators to zebras), cageless habitats, exhibits & a train.",
      "poi_long_description": "Sprawling zoo with 750 species (from alligators to zebras), cageless habitats, exhibits & a train.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f14fe-2ade-7079-9044-39144d2fb3aa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fe-2ade-7079-9044-39144d2fb3aa",
        "storage_key": "property/5757666374713344/019f14fe-2ade-7079-9044-39144d2fb3aa.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://sazoo.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3014278567356514980&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "san-antonio-zoo",
      "poi_latitude": "29.4635835",
      "poi_longitude": "-98.4725926",
      "poi_miles_from_property": "10.1 mi",
      "poi_walking_minutes": "3 hours 45 mins",
      "poi_biking_minutes": "59 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 210-734-7184",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f14fb-e0ee-76ca-a881-f4e43cbd8c14.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fb-e0ee-76ca-a881-f4e43cbd8c14",
        "storage_key": "property/5757666374713344/019f14fb-e0ee-76ca-a881-f4e43cbd8c14.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJjWXd2Jr1XIYRpMJb_WLe1Ck",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "zoo"
    },
    {
      "id": "ec_f41c64f8fc7f5d3167866082",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "source": "generator",
      "poi_name": "Natural Bridge Caverns",
      "poi_type": "Entertainment",
      "poi_address": "26495 Natural Bridge Caverns Rd, San Antonio, TX 78266, USA",
      "poi_short_description": "Popular spot with subterranean cavern tours & an elevated adventure course, plus a cafe & gift shop.",
      "poi_long_description": "Popular spot with subterranean cavern tours & an elevated adventure course, plus a cafe & gift shop.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f14fe-2ed8-74ff-9974-280c8514c9c2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fe-2ed8-74ff-9974-280c8514c9c2",
        "storage_key": "property/5757666374713344/019f14fe-2ed8-74ff-9974-280c8514c9c2.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://naturalbridgecaverns.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1656162311468172447&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "natural-bridge-caverns",
      "poi_latitude": "29.6924095",
      "poi_longitude": "-98.3427276",
      "poi_miles_from_property": "28.4 mi",
      "poi_walking_minutes": "10 hours 31 mins",
      "poi_biking_minutes": "2 hours 47 mins",
      "poi_driving_minutes": "40 mins",
      "poi_business_phone": "+1 210-651-6101",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f14fb-e0af-7690-a574-bb49693d598a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fb-e0af-7690-a574-bb49693d598a",
        "storage_key": "property/5757666374713344/019f14fb-e0af-7690-a574-bb49693d598a.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJpxaV65mPXIYRn0Rz-dje-xY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nature_preserve"
    },
    {
      "id": "ec_6fd79b6403126ce42da87b21",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "source": "generator",
      "poi_name": "Tobin Center for the Performing Arts",
      "poi_type": "Entertainment",
      "poi_address": "100 Auditorium Cir, San Antonio, TX 78205, USA",
      "poi_short_description": "Large venue hosting Broadway tours and concerts of many genres, plus ballet and other live events.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f14fe-2cce-7259-8fa0-421456ab9fd7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fe-2cce-7259-8fa0-421456ab9fd7",
        "storage_key": "property/5757666374713344/019f14fe-2cce-7259-8fa0-421456ab9fd7.webp",
        "width": 930,
        "height": 523
      },
      "poi_business_url": "https://www.tobincenter.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12854864989977135831&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tobin-center-for-the-performing-arts",
      "poi_latitude": "29.4306593",
      "poi_longitude": "-98.4887048",
      "poi_miles_from_property": "9.9 mi",
      "poi_walking_minutes": "3 hours 43 mins",
      "poi_biking_minutes": "56 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 210-223-8624",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f14fb-e0ee-76ca-a881-f4e43cbd8c14.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fb-e0ee-76ca-a881-f4e43cbd8c14",
        "storage_key": "property/5757666374713344/019f14fb-e0ee-76ca-a881-f4e43cbd8c14.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJfVwRGlRfXIYR10oxs5mnZbI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "ec_940fed24cfdc987acfa8ae68",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "source": "generator",
      "poi_name": "Foundation Surgical Hospital of San Antonio",
      "poi_type": "Health and Wellness",
      "poi_address": "9522 Huebner Rd, San Antonio, TX 78240, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f14fe-2ee0-71ab-9a8f-6112a9d29428.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fe-2ee0-71ab-9a8f-6112a9d29428",
        "storage_key": "property/5757666374713344/019f14fe-2ee0-71ab-9a8f-6112a9d29428.webp",
        "width": 1280,
        "height": 835
      },
      "poi_business_url": "http://www.fshsanantonio.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17614582165021672704&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "foundation-surgical-hospital-of-san-antonio",
      "poi_latitude": "29.5302381",
      "poi_longitude": "-98.5900498",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 210-478-5400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f14fb-e0ee-76ca-a881-f4e43cbd8c14.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fb-e0ee-76ca-a881-f4e43cbd8c14",
        "storage_key": "property/5757666374713344/019f14fb-e0ee-76ca-a881-f4e43cbd8c14.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2Sw4FkFnXIYRAEUMLSeRc_Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_2017a5f7497d27bdfd35937c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "source": "generator",
      "poi_name": "Epic Pain Management, PLLC",
      "poi_type": "Health and Wellness",
      "poi_address": "5939 Babcock Rd #112, San Antonio, TX 78240, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f14fe-33e3-7213-b8bb-069b0a384271.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fe-33e3-7213-b8bb-069b0a384271",
        "storage_key": "property/5757666374713344/019f14fe-33e3-7213-b8bb-069b0a384271.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.epic-pain.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1610674675076464994&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "epic-pain-management-pllc",
      "poi_latitude": "29.528942",
      "poi_longitude": "-98.6017672",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 210-874-5260",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f14fb-e0ee-76ca-a881-f4e43cbd8c14.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fb-e0ee-76ca-a881-f4e43cbd8c14",
        "storage_key": "property/5757666374713344/019f14fb-e0ee-76ca-a881-f4e43cbd8c14.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJq4t_vSBdXIYRYoGmUBVEWhY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "doctor"
    },
    {
      "id": "ec_12a13d137c550e220682f482",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "source": "generator",
      "poi_name": "CVS",
      "poi_type": "Health and Wellness",
      "poi_address": "4805 Medical Dr, San Antonio, TX 78229, USA",
      "poi_short_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_long_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f14fe-3454-73bc-8a0c-ea306a13fced.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fe-3454-73bc-8a0c-ea306a13fced",
        "storage_key": "property/5757666374713344/019f14fe-3454-73bc-8a0c-ea306a13fced.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.cvs.com/store-locator/san-antonio-tx-pharmacies/4805-medical-dr-san-antonio-tx-78229/storeid=7808?WT.mc_id=LS_GOOGLE_FS_7808",
      "poi_directions_map_url": "https://maps.google.com/?cid=17482205379898885682&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs",
      "poi_latitude": "29.5111607",
      "poi_longitude": "-98.5805579",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 210-616-0482",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f14fb-e0ee-76ca-a881-f4e43cbd8c14.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fb-e0ee-76ca-a881-f4e43cbd8c14",
        "storage_key": "property/5757666374713344/019f14fb-e0ee-76ca-a881-f4e43cbd8c14.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJH53vfPhdXIYRMsZLFytFnfI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "ec_c1b3dce13e31a79fa3c94753",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "source": "generator",
      "poi_name": "H-E-B Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "5910 Babcock Rd, San Antonio, TX 78240, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f14fe-345a-7369-a92f-82a0e2f524bd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fe-345a-7369-a92f-82a0e2f524bd",
        "storage_key": "property/5757666374713344/019f14fe-345a-7369-a92f-82a0e2f524bd.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://www.heb.com/pharmacy/common/landing?utm_source=google&utm_medium=organic&utm_campaign=gmb_pharmacy",
      "poi_directions_map_url": "https://maps.google.com/?cid=9187098154032197368&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "h-e-b-pharmacy",
      "poi_latitude": "29.5266244",
      "poi_longitude": "-98.6036054",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 210-641-6405",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f14fe-5ed0-73d8-9924-622cdb50c635.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fe-5ed0-73d8-9924-622cdb50c635",
        "storage_key": "property/5757666374713344/019f14fe-5ed0-73d8-9924-622cdb50c635.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4_7ZM29nXIYR-G68gxghf38",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_2d25d567c2804459716e073c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "source": "generator",
      "poi_name": "Walgreens",
      "poi_type": "Health and Wellness",
      "poi_address": "7802 Wurzbach Rd, San Antonio, TX 78229, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f14fe-3c18-75fd-8011-4ecf999b5fc1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fe-3c18-75fd-8011-4ecf999b5fc1",
        "storage_key": "property/5757666374713344/019f14fe-3c18-75fd-8011-4ecf999b5fc1.webp",
        "width": 1280,
        "height": 576
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-7802+wurzbach+rd-san+antonio-tx-78229/id=2458",
      "poi_directions_map_url": "https://maps.google.com/?cid=8179242390089165625&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "29.5106025",
      "poi_longitude": "-98.5793548",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 210-614-3590",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f14fb-e0ee-76ca-a881-f4e43cbd8c14.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fb-e0ee-76ca-a881-f4e43cbd8c14",
        "storage_key": "property/5757666374713344/019f14fb-e0ee-76ca-a881-f4e43cbd8c14.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJDWSPjPhdXIYROesUSZ6BgnE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "ec_8b104c3fd96a7e216c72d8d9",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "source": "generator",
      "poi_name": "Anytime Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "9023 Huebner Rd Ste 100, San Antonio, TX 78240, USA",
      "poi_short_description": "Membership-based chain gym at Huebner Commons Shopping Center featuring equipment.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f14fe-3bcf-7728-8409-3f571ac5ec9e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fe-3bcf-7728-8409-3f571ac5ec9e",
        "storage_key": "property/5757666374713344/019f14fe-3bcf-7728-8409-3f571ac5ec9e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.anytimefitness.com/locations/san-antonio-texas-1288/?utm_source=google&utm_medium=organic-businesslisting&utm_campaign=gbp-listing&utm_content=1288",
      "poi_directions_map_url": "https://maps.google.com/?cid=5173018794286032316&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "anytime-fitness",
      "poi_latitude": "29.5267467",
      "poi_longitude": "-98.5974653",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 210-596-4033",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f14fb-e0ee-76ca-a881-f4e43cbd8c14.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fb-e0ee-76ca-a881-f4e43cbd8c14",
        "storage_key": "property/5757666374713344/019f14fb-e0ee-76ca-a881-f4e43cbd8c14.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJeQXxcWlnXIYRvKXWgS9Bykc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_f625ab65cd4324323551f35a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "source": "generator",
      "poi_name": "LA Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "5803 Babcock Rd, San Antonio, TX 78240, USA",
      "poi_short_description": "Health club chain offering state-of-the-art facilities, such as cardio and weight machines, plus pools and basketball courts.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f14fb-adc0-77fe-a2af-6adf4f809348.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fb-adc0-77fe-a2af-6adf4f809348",
        "storage_key": "property/5757666374713344/019f14fb-adc0-77fe-a2af-6adf4f809348.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.lafitness.com/Pages/clubhome.aspx?clubid=967&utm_source=google&utm_medium=googlemaps&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=2947319426764646106&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "la-fitness",
      "poi_latitude": "29.5257177",
      "poi_longitude": "-98.598914",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 210-202-3139",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f14fb-e0ee-76ca-a881-f4e43cbd8c14.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fb-e0ee-76ca-a881-f4e43cbd8c14",
        "storage_key": "property/5757666374713344/019f14fb-e0ee-76ca-a881-f4e43cbd8c14.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJl7zRM29nXIYR2ibqL2f75ig",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_bccc03f11439c52644087fab",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "source": "generator",
      "poi_name": "F45 Training Medical Center SATX",
      "poi_type": "Health and Wellness",
      "poi_address": "10103 Huebner Rd, San Antonio, TX 78240, USA",
      "poi_short_description": "Fun, welcoming gym chain with 45-minute workouts mixing cardio and strength training.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f14fe-3ce9-77f8-b416-ef46e8e4cee2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fe-3ce9-77f8-b416-ef46e8e4cee2",
        "storage_key": "property/5757666374713344/019f14fe-3ce9-77f8-b416-ef46e8e4cee2.webp",
        "width": 1280,
        "height": 855
      },
      "poi_business_url": "https://f45training.com/studio/medicalcentersatx/",
      "poi_directions_map_url": "https://maps.google.com/?cid=865267914243963893&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "f45-training-medical-center-satx",
      "poi_latitude": "29.5371719",
      "poi_longitude": "-98.5871691",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 210-960-3245",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f14fb-e0ee-76ca-a881-f4e43cbd8c14.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fb-e0ee-76ca-a881-f4e43cbd8c14",
        "storage_key": "property/5757666374713344/019f14fb-e0ee-76ca-a881-f4e43cbd8c14.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJh3hjIY1nXIYR9fsNaJUMAgw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_b16b0e1d3c34c4be3c088f2b",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "source": "generator",
      "poi_name": "YogaSix Stone Oak",
      "poi_type": "Health and Wellness",
      "poi_address": "23714 Hardy Oak Blvd Ste 105, San Antonio, TX 78258, USA",
      "poi_short_description": "Yoga studio offering a sensory experience with a variety of classes, including hot yoga.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f14fe-3c8f-7404-a178-85b38e897503.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fe-3c8f-7404-a178-85b38e897503",
        "storage_key": "property/5757666374713344/019f14fe-3c8f-7404-a178-85b38e897503.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://www.yogasix.com/stone-oak",
      "poi_directions_map_url": "https://maps.google.com/?cid=10985574319054874530&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "yogasix-stone-oak",
      "poi_latitude": "29.6615082",
      "poi_longitude": "-98.5018694",
      "poi_miles_from_property": "11.8 mi",
      "poi_walking_minutes": "4 hours 27 mins",
      "poi_biking_minutes": "1 hour 23 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 210-960-0650",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f14fb-e096-776e-8daa-830462c5fbe4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fb-e096-776e-8daa-830462c5fbe4",
        "storage_key": "property/5757666374713344/019f14fb-e096-776e-8daa-830462c5fbe4.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJhyDVcBRjXIYRomfrnKOZdJg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "ec_b1464953739c1cae2df003f8",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "source": "generator",
      "poi_name": "Leon Vista Park and Trailhead",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "8561 Rochelle Rd, San Antonio, TX 78240, USA",
      "poi_short_description": "Kid-friendly, wildlife-filled park featuring various trails for walking, hiking and biking.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f14fe-4002-73b2-923e-5f55fe3d975a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fe-4002-73b2-923e-5f55fe3d975a",
        "storage_key": "property/5757666374713344/019f14fe-4002-73b2-923e-5f55fe3d975a.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.sa.gov/Directory/Departments/Parks/Parks-Facilities/Parks/Directory/Leon-Vista-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=11245610794023394979&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "leon-vista-park-and-trailhead",
      "poi_latitude": "29.5229254",
      "poi_longitude": "-98.6247785",
      "poi_miles_from_property": "5.9 mi",
      "poi_walking_minutes": "2 hours 8 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 210-207-8480",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f14fb-e0af-7690-a574-bb49693d598a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fb-e0af-7690-a574-bb49693d598a",
        "storage_key": "property/5757666374713344/019f14fb-e0af-7690-a574-bb49693d598a.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJRWAXAZtnXIYRox4QdG9vEJw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_125cb23354026b8fe54be885",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "source": "generator",
      "poi_name": "Gorrell Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "San Antonio, TX 78249, USA",
      "poi_short_description": "Kid-friendly, wooded outdoor space featuring picnic tables, a playground and trail walks.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f14fe-477f-709b-95c0-9d97ce31248f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fe-477f-709b-95c0-9d97ce31248f",
        "storage_key": "property/5757666374713344/019f14fe-477f-709b-95c0-9d97ce31248f.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.sanantonio.gov/ParksAndRec/Parks-Facilities/All-Parks-Facilities/Parks-Facilities-Details/ArtMID/14820/ArticleID/2641/Gorrell-Park?Park=85&Facility=",
      "poi_directions_map_url": "https://maps.google.com/?cid=12748726381435388656&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gorrell-park",
      "poi_latitude": "29.5675272",
      "poi_longitude": "-98.5768874",
      "poi_miles_from_property": "3.8 mi",
      "poi_walking_minutes": "1 hour 26 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f14fb-e0af-7690-a574-bb49693d598a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fb-e0af-7690-a574-bb49693d598a",
        "storage_key": "property/5757666374713344/019f14fb-e0af-7690-a574-bb49693d598a.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJy0wKR-lnXIYR8IIbKBmT7LA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_9e4d4f22232f24635bbeedb5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "source": "generator",
      "poi_name": "Fox Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "6518 W Hausman Rd, San Antonio, TX 78249, USA",
      "poi_short_description": "Deer & other local wildlife can frequently be seen at this city park with walking/cycling trails.",
      "poi_long_description": "Deer & other local wildlife can frequently be seen at this city park with walking/cycling trails.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f14fe-41a3-77da-93cd-4ab2d1898656.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fe-41a3-77da-93cd-4ab2d1898656",
        "storage_key": "property/5757666374713344/019f14fe-41a3-77da-93cd-4ab2d1898656.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.sa.gov/Directory/Departments/Parks/Parks-Facilities/Parks/Directory/Fox-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=1857581849663715813&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fox-park",
      "poi_latitude": "29.5716827",
      "poi_longitude": "-98.6182997",
      "poi_miles_from_property": "4.8 mi",
      "poi_walking_minutes": "1 hour 47 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 210-207-8480",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f14fb-e0af-7690-a574-bb49693d598a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fb-e0af-7690-a574-bb49693d598a",
        "storage_key": "property/5757666374713344/019f14fb-e0af-7690-a574-bb49693d598a.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJgyfTEVlmXIYR5Tlrstl0xxk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_3461da13ea18eac6370481ae",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "source": "generator",
      "poi_name": "Bamberger Nature Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "12401 Babcock Rd, San Antonio, TX 78249, USA",
      "poi_short_description": "This tree-filled natural area offers trails for hiking & cycling, plus a playground.",
      "poi_long_description": "This tree-filled natural area offers trails for hiking & cycling, plus a playground.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f14fe-445f-73ed-ad21-1fa7660c1cab.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fe-445f-73ed-ad21-1fa7660c1cab",
        "storage_key": "property/5757666374713344/019f14fe-445f-73ed-ad21-1fa7660c1cab.webp",
        "width": 1280,
        "height": 1018
      },
      "poi_business_url": "https://www.sanantonio.gov/ParksAndRec/Parks-Facilities/All-Parks-Facilities/Parks-Facilities-Details/ArtMID/14820/ArticleID/2435/Bamberger-Nature-Park?Park=11&Facility=",
      "poi_directions_map_url": "https://maps.google.com/?cid=1927048889006278731&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bamberger-nature-park",
      "poi_latitude": "29.5610152",
      "poi_longitude": "-98.6291246",
      "poi_miles_from_property": "5.2 mi",
      "poi_walking_minutes": "1 hour 55 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 210-207-7275",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f14fb-e0af-7690-a574-bb49693d598a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fb-e0af-7690-a574-bb49693d598a",
        "storage_key": "property/5757666374713344/019f14fb-e0af-7690-a574-bb49693d598a.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJawzKcU5mXIYRS8gHLsFAvho",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nature_preserve"
    },
    {
      "id": "ec_ef3c5064aea2f662c388451c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "source": "generator",
      "poi_name": "Earl Scott Pond",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "13101 Babcock Rd, San Antonio, TX 78249, USA",
      "poi_short_description": "Popular park with kid-friendly trails and a stocked pond for fishing and wildlife watching.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f14fe-4181-766d-8b43-29c4b3d018e6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fe-4181-766d-8b43-29c4b3d018e6",
        "storage_key": "property/5757666374713344/019f14fe-4181-766d-8b43-29c4b3d018e6.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=9276180710225921778&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "earl-scott-pond",
      "poi_latitude": "29.5542923",
      "poi_longitude": "-98.629237",
      "poi_miles_from_property": "4.8 mi",
      "poi_walking_minutes": "1 hour 46 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f14fb-e0af-7690-a574-bb49693d598a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fb-e0af-7690-a574-bb49693d598a",
        "storage_key": "property/5757666374713344/019f14fb-e0af-7690-a574-bb49693d598a.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJSyPeWEhnXIYR8sZYaTWdu4A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_fb334ab738b98cfcc2e4c459",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "source": "generator",
      "poi_name": "Orsinger Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "12230 Huebner Rd, San Antonio, TX 78230, USA",
      "poi_short_description": "Bustling urban park features trails, a playground & picnic pavilion with a rental kitchen facility.",
      "poi_long_description": "Bustling urban park features trails, a playground & picnic pavilion with a rental kitchen facility.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f14fe-4440-703d-ac74-10e18318c66e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fe-4440-703d-ac74-10e18318c66e",
        "storage_key": "property/5757666374713344/019f14fe-4440-703d-ac74-10e18318c66e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.bexar.org/3656/Orsinger-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=5268560010445158440&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "orsinger-park",
      "poi_latitude": "29.5569111",
      "poi_longitude": "-98.5648909",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 210-335-7275",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f14fb-e0af-7690-a574-bb49693d598a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fb-e0af-7690-a574-bb49693d598a",
        "storage_key": "property/5757666374713344/019f14fb-e0af-7690-a574-bb49693d598a.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJMcW9RtZgXIYRKHhpXGqvHUk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_ec1e40901277357965639cac",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "source": "generator",
      "poi_name": "O. P. Schnabel Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "9606 Bandera Rd, San Antonio, TX 78250, USA",
      "poi_short_description": "Sprawling 202-acre park with nature trails, pavilions, picnic tables, athletic fields & a playscape.",
      "poi_long_description": "Sprawling 202-acre park with nature trails, pavilions, picnic tables, athletic fields & a playscape.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f14fb-b15c-738f-982a-58bfe72556a4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fb-b15c-738f-982a-58bfe72556a4",
        "storage_key": "property/5757666374713344/019f14fb-b15c-738f-982a-58bfe72556a4.webp",
        "width": 1209,
        "height": 1280
      },
      "poi_business_url": "https://www.sa.gov/Directory/Departments/Parks/Parks-Facilities/Parks/Directory/O-P-Schnabel",
      "poi_directions_map_url": "https://maps.google.com/?cid=16813810842197915761&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "o-p-schnabel-park",
      "poi_latitude": "29.53512",
      "poi_longitude": "-98.6407568",
      "poi_miles_from_property": "4.9 mi",
      "poi_walking_minutes": "1 hour 48 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 210-207-7275",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f14fb-e0af-7690-a574-bb49693d598a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fb-e0af-7690-a574-bb49693d598a",
        "storage_key": "property/5757666374713344/019f14fb-e0af-7690-a574-bb49693d598a.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2w2aH8FnXIYRcXjRqeCnVuk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "ec_7ffd20266abb6c314284031d",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "source": "generator",
      "poi_name": "Prue Road Trailhead",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "7508 Prue Rd, San Antonio, TX 78249, USA",
      "poi_short_description": "Local hiking area featuring wide paths, grassy fields, deer and more, plus a parking lot.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f14fe-4762-7439-b668-854f440dba96.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fe-4762-7439-b668-854f440dba96",
        "storage_key": "property/5757666374713344/019f14fe-4762-7439-b668-854f440dba96.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=18177960657801468808&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "prue-road-trailhead",
      "poi_latitude": "29.541926",
      "poi_longitude": "-98.633296",
      "poi_miles_from_property": "4.5 mi",
      "poi_walking_minutes": "1 hour 39 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f14fb-e0ee-76ca-a881-f4e43cbd8c14.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fb-e0ee-76ca-a881-f4e43cbd8c14",
        "storage_key": "property/5757666374713344/019f14fb-e0ee-76ca-a881-f4e43cbd8c14.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJibY7X5FnXIYRiFtIRegWRfw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hiking_area"
    },
    {
      "id": "ec_9c4d4fb9a70246c7dc137877",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "source": "generator",
      "poi_name": "Medical Center Transit Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "5330 Medical Dr, San Antonio, TX 78240, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f14fe-4a19-77db-a507-3d63d7895de5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fe-4a19-77db-a507-3d63d7895de5",
        "storage_key": "property/5757666374713344/019f14fe-4a19-77db-a507-3d63d7895de5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.viainfo.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17748660839738358253&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "medical-center-transit-station",
      "poi_latitude": "29.5076924",
      "poi_longitude": "-98.5896433",
      "poi_miles_from_property": "3.1 mi",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 210-362-2896",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f14fb-e0ee-76ca-a881-f4e43cbd8c14.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fb-e0ee-76ca-a881-f4e43cbd8c14",
        "storage_key": "property/5757666374713344/019f14fb-e0ee-76ca-a881-f4e43cbd8c14.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJl0GJN_RdXIYR7bl9T__oT_Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "ec_5dbd3e7a0dc6ab01f35d7b40",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "source": "generator",
      "poi_name": "Usaa Blvd & Huebner",
      "poi_type": "Transportation & Transit",
      "poi_address": "San Antonio, TX 78240, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=15468252774415817284&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "usaa-blvd--huebner",
      "poi_latitude": "29.535535",
      "poi_longitude": "-98.587094",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f14fb-e0ee-76ca-a881-f4e43cbd8c14.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fb-e0ee-76ca-a881-f4e43cbd8c14",
        "storage_key": "property/5757666374713344/019f14fb-e0ee-76ca-a881-f4e43cbd8c14.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJgSoJlThnXIYRRFoBq_FFqtY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "ec_55d8034d60aece809af3da20",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "source": "generator",
      "poi_name": "Usaa Blvd & Fredericksburg Rd.",
      "poi_type": "Transportation & Transit",
      "poi_address": "San Antonio, TX 78240, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=8497820788687045874&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "usaa-blvd--fredericksburg-rd",
      "poi_latitude": "29.53719",
      "poi_longitude": "-98.5788",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f14fb-e0ee-76ca-a881-f4e43cbd8c14.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fb-e0ee-76ca-a881-f4e43cbd8c14",
        "storage_key": "property/5757666374713344/019f14fb-e0ee-76ca-a881-f4e43cbd8c14.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJAcgYZzZnXIYR8gSf4vtS7nU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "ec_e31284d969cb6607aee67ae0",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "source": "generator",
      "poi_name": "Nw Loop 410 W Access Rd At Ent To Txdot",
      "poi_type": "Transportation & Transit",
      "poi_address": "San Antonio, TX 78229, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=7624223773638996657&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "nw-loop-410-w-access-rd-at-ent-to-txdot",
      "poi_latitude": "29.489968",
      "poi_longitude": "-98.575907",
      "poi_miles_from_property": "4.3 mi",
      "poi_walking_minutes": "1 hour 38 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f14fe-5ece-751a-9899-f4d8bbb9ed85.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fe-5ece-751a-9899-f4d8bbb9ed85",
        "storage_key": "property/5757666374713344/019f14fe-5ece-751a-9899-f4d8bbb9ed85.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJmzyuluBdXIYRsTLXkyCvzmk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_station"
    },
    {
      "id": "ec_16906a46649787722e4c7ab6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "source": "generator",
      "poi_name": "VIA Crossroads Park & Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "151 N Crossroads Blvd, Balcones Heights, TX 78201, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f14fe-508f-70d8-a62f-ae2ed4d91f6f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fe-508f-70d8-a62f-ae2ed4d91f6f",
        "storage_key": "property/5757666374713344/019f14fe-508f-70d8-a62f-ae2ed4d91f6f.webp",
        "width": 1280,
        "height": 577
      },
      "poi_business_url": "http://viainfo.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14912817806174523366&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "via-crossroads-park--ride",
      "poi_latitude": "29.493575",
      "poi_longitude": "-98.5483679",
      "poi_miles_from_property": "4.3 mi",
      "poi_walking_minutes": "1 hour 37 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 210-362-2892",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f14fe-5ece-751a-9899-f3349034a04a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fe-5ece-751a-9899-f3349034a04a",
        "storage_key": "property/5757666374713344/019f14fe-5ece-751a-9899-f3349034a04a.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJNXQTzYRfXIYR5g8ngcj49M4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    },
    {
      "id": "ec_4d54c3bf2d2aebaf4685af50",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "source": "generator",
      "poi_name": "Ingram Transit Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "3215 Northwestern Dr, San Antonio, TX 78238, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f14fe-4cda-7733-ad30-ae09eb2ea759.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fe-4cda-7733-ad30-ae09eb2ea759",
        "storage_key": "property/5757666374713344/019f14fe-4cda-7733-ad30-ae09eb2ea759.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.viainfo.net/transit-centers/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15286896482762599812&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ingram-transit-center",
      "poi_latitude": "29.4648153",
      "poi_longitude": "-98.6257608",
      "poi_miles_from_property": "6.8 mi",
      "poi_walking_minutes": "2 hours 31 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 210-521-6773",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f14fb-e0ee-76ca-a881-f4e43cbd8c14.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fb-e0ee-76ca-a881-f4e43cbd8c14",
        "storage_key": "property/5757666374713344/019f14fb-e0ee-76ca-a881-f4e43cbd8c14.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJryXVZVvZ-4YRhK07jVv3JdQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "ec_c1dc452417a11e6b61c94279",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "source": "generator",
      "poi_name": "Chestnut @ Ellis Alley Park & Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "San Antonio, TX 78202, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f14fe-4ae2-71e7-87b6-5b87ebbf476a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fe-4ae2-71e7-87b6-5b87ebbf476a",
        "storage_key": "property/5757666374713344/019f14fe-4ae2-71e7-87b6-5b87ebbf476a.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=17942887006879847955&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chestnut--ellis-alley-park--ride",
      "poi_latitude": "29.423515",
      "poi_longitude": "-98.479719",
      "poi_miles_from_property": "10.7 mi",
      "poi_walking_minutes": "3 hours 59 mins",
      "poi_biking_minutes": "1 hour 3 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f14fb-e0ee-76ca-a881-f4e43cbd8c14.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fb-e0ee-76ca-a881-f4e43cbd8c14",
        "storage_key": "property/5757666374713344/019f14fb-e0ee-76ca-a881-f4e43cbd8c14.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJr4vm2wD2XIYRE5YL0qrwAfk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "ec_030f848aac953de5526c8587",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "source": "generator",
      "poi_name": "North Star Transit Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "7538 San Pedro Ave, San Antonio, TX 78216, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f14fe-50d2-759a-a1b2-14bb7bca1048.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fe-50d2-759a-a1b2-14bb7bca1048",
        "storage_key": "property/5757666374713344/019f14fe-50d2-759a-a1b2-14bb7bca1048.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "http://www.viainfo.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10414624133700210677&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "north-star-transit-center",
      "poi_latitude": "29.51912",
      "poi_longitude": "-98.49871",
      "poi_miles_from_property": "7.8 mi",
      "poi_walking_minutes": "2 hours 53 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 210-409-7788",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f14fb-e0ee-76ca-a881-f4e43cbd8c14.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fb-e0ee-76ca-a881-f4e43cbd8c14",
        "storage_key": "property/5757666374713344/019f14fb-e0ee-76ca-a881-f4e43cbd8c14.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJRbAqpAlgXIYR9U9pdngtiJA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "ec_353c02e21f588e639e13ece6",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "source": "generator",
      "poi_name": "San Antonio International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "9800 Airport Blvd, San Antonio, TX 78216, USA",
      "poi_short_description": "Airport offering international flights plus eateries & car-rental options.",
      "poi_long_description": "Airport offering international flights plus eateries & car-rental options.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f14fe-5128-76bf-9e83-15a437ad6bd7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fe-5128-76bf-9e83-15a437ad6bd7",
        "storage_key": "property/5757666374713344/019f14fe-5128-76bf-9e83-15a437ad6bd7.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.flysanantonio.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18041828760938859602&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "san-antonio-international-airport",
      "poi_latitude": "29.5331282",
      "poi_longitude": "-98.4705422",
      "poi_miles_from_property": "10.4 mi",
      "poi_walking_minutes": "3 hours 52 mins",
      "poi_biking_minutes": "57 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 210-207-3433",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f14fb-e089-7498-a216-fc11aae51370.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fb-e089-7498-a216-fc11aae51370",
        "storage_key": "property/5757666374713344/019f14fb-e089-7498-a216-fc11aae51370.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJJ4DLsbuKXIYRUswvGqtzYfo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "ec_25fdf0f8dedc329e2b676a82",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "source": "generator",
      "poi_name": "USAA Corporate Office",
      "poi_type": "Major Employers & Offices",
      "poi_address": "9800 Fredericksburg Rd, San Antonio, TX 78288, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f14fb-c86a-71b9-a7fe-fbdc670bcbce.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fb-c86a-71b9-a7fe-fbdc670bcbce",
        "storage_key": "property/5757666374713344/019f14fb-c86a-71b9-a7fe-fbdc670bcbce.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.usaa.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7341051404387659836&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "usaa-corporate-office",
      "poi_latitude": "29.5371902",
      "poi_longitude": "-98.5752478",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 800-531-8722",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f14fb-e0ee-76ca-a881-f4e43cbd8c14.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fb-e0ee-76ca-a881-f4e43cbd8c14",
        "storage_key": "property/5757666374713344/019f14fb-e0ee-76ca-a881-f4e43cbd8c14.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJyyb6ITJnXIYRPLBolFun4GU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "ec_aa35693ac8839b179a6f6987",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "source": "generator",
      "poi_name": "Foundation Surgical Hospital of San Antonio",
      "poi_type": "Major Employers & Offices",
      "poi_address": "9522 Huebner Rd, San Antonio, TX 78240, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f14fe-2ee0-71ab-9a8f-6112a9d29428.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fe-2ee0-71ab-9a8f-6112a9d29428",
        "storage_key": "property/5757666374713344/019f14fe-2ee0-71ab-9a8f-6112a9d29428.webp",
        "width": 1280,
        "height": 835
      },
      "poi_business_url": "http://www.fshsanantonio.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17614582165021672704&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "foundation-surgical-hospital-of-san-antonio",
      "poi_latitude": "29.5302381",
      "poi_longitude": "-98.5900498",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 210-478-5400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f14fb-e0ee-76ca-a881-f4e43cbd8c14.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fb-e0ee-76ca-a881-f4e43cbd8c14",
        "storage_key": "property/5757666374713344/019f14fb-e0ee-76ca-a881-f4e43cbd8c14.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2Sw4FkFnXIYRAEUMLSeRc_Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_b4149778dd0488663d82c9ad",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "source": "generator",
      "poi_name": "UT Health San Antonio Long (Main) Campus",
      "poi_type": "Major Employers & Offices",
      "poi_address": "7703 Floyd Curl Dr, San Antonio, TX 78229, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f14fe-5315-740d-a3af-d39ce3312b1b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fe-5315-740d-a3af-d39ce3312b1b",
        "storage_key": "property/5757666374713344/019f14fe-5315-740d-a3af-d39ce3312b1b.webp",
        "width": 800,
        "height": 533
      },
      "poi_business_url": "https://www.uthscsa.edu/patient-care/physicians/location/UT-Health-San-Antonio-Main-Campus?utm_source=google&utm_medium=Yext",
      "poi_directions_map_url": "https://maps.google.com/?cid=5342454117936685534&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ut-health-san-antonio-long-main-campus",
      "poi_latitude": "29.5075039",
      "poi_longitude": "-98.5754327",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 210-450-6400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f14fb-e050-701c-95ec-e23d784207a2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fb-e050-701c-95ec-e23d784207a2",
        "storage_key": "property/5757666374713344/019f14fb-e050-701c-95ec-e23d784207a2.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJS4WfQ_5dXIYR3mFw-LY1JEo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_e84ecfeee65c7922115beed5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "source": "generator",
      "poi_name": "South Texas Medical Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "8255 Fredericksburg Rd, San Antonio, TX 78229, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f14fe-546f-70ef-928f-0c53765b6460.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fe-546f-70ef-928f-0c53765b6460",
        "storage_key": "property/5757666374713344/019f14fe-546f-70ef-928f-0c53765b6460.webp",
        "width": 1280,
        "height": 451
      },
      "poi_business_url": "http://southtexasmed.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14707428742730498138&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "south-texas-medical-center",
      "poi_latitude": "29.5162073",
      "poi_longitude": "-98.5724386",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 210-230-6799",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f14fb-e050-701c-95ec-e23d784207a2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fb-e050-701c-95ec-e23d784207a2",
        "storage_key": "property/5757666374713344/019f14fb-e050-701c-95ec-e23d784207a2.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJf0bjS1ZnXIYRWkDSqYRIG8w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_center"
    },
    {
      "id": "ec_aeb33dd8ed1797b5a13dfadd",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "source": "generator",
      "poi_name": "Valero",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1 Valero Way, San Antonio, TX 78249, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f14fb-d166-757e-81bb-f7f5209d46fd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fb-d166-757e-81bb-f7f5209d46fd",
        "storage_key": "property/5757666374713344/019f14fb-d166-757e-81bb-f7f5209d46fd.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.valero.com/ourbusiness/ourlocations/offices/pages/valerocorporateheadquarters.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=16201185604516536043&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "valero",
      "poi_latitude": "29.5869869",
      "poi_longitude": "-98.6070957",
      "poi_miles_from_property": "5.3 mi",
      "poi_walking_minutes": "2 hours 0 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 210-345-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f14fb-e0ee-76ca-a881-f4e43cbd8c14.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fb-e0ee-76ca-a881-f4e43cbd8c14",
        "storage_key": "property/5757666374713344/019f14fb-e0ee-76ca-a881-f4e43cbd8c14.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJv1eqHI5mXIYR615hQXgs1uA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "ec_974dbce5b8ed1bf81e5d2f94",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "source": "generator",
      "poi_name": "H-E-B Corporate Office Headquarters",
      "poi_type": "Major Employers & Offices",
      "poi_address": "646 S Flores St, San Antonio, TX 78204, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f14fe-5482-7023-921b-6896f6b6cd97.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fe-5482-7023-921b-6896f6b6cd97",
        "storage_key": "property/5757666374713344/019f14fe-5482-7023-921b-6896f6b6cd97.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.heb.com/static-page/heb-corporate-office-hq",
      "poi_directions_map_url": "https://maps.google.com/?cid=10485037645668446608&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "h-e-b-corporate-office-headquarters",
      "poi_latitude": "29.4172323",
      "poi_longitude": "-98.4954226",
      "poi_miles_from_property": "10.5 mi",
      "poi_walking_minutes": "3 hours 56 mins",
      "poi_biking_minutes": "1 hour 5 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 210-938-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f14fb-e0ee-76ca-a881-f4e43cbd8c14.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fb-e0ee-76ca-a881-f4e43cbd8c14",
        "storage_key": "property/5757666374713344/019f14fb-e0ee-76ca-a881-f4e43cbd8c14.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJHfrImLFYXIYRkHGqxi9WgpE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "ec_973dbd633757b25f1c0ee4b5",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "source": "generator",
      "poi_name": "Brooke Army Medical Center (BAMC)",
      "poi_type": "Major Employers & Offices",
      "poi_address": "3551 Roger Brooke Dr, Fort Sam Houston, TX 78234, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f14fe-5857-749f-864d-d00e7e58a898.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fe-5857-749f-864d-d00e7e58a898",
        "storage_key": "property/5757666374713344/019f14fe-5857-749f-864d-d00e7e58a898.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://bamc.tricare.mil/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5581840337299951468&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "brooke-army-medical-center-bamc",
      "poi_latitude": "29.460187",
      "poi_longitude": "-98.4162656",
      "poi_miles_from_property": "15.0 mi",
      "poi_walking_minutes": "5 hours 33 mins",
      "poi_biking_minutes": "1 hour 46 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 210-916-7500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f14fb-e050-701c-95ec-e23d784207a2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fb-e050-701c-95ec-e23d784207a2",
        "storage_key": "property/5757666374713344/019f14fb-e050-701c-95ec-e23d784207a2.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJN8nfo2n0XIYRbM-1gTaudk0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_8806ca5eb4710cc839f9970a",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "source": "generator",
      "poi_name": "Toyota Motor Manufacturing, Texas, Inc.",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1 Lone Star Pass, San Antonio, TX 78264, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f14fe-5572-74e8-8c06-e2cdf9df4d82.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fe-5572-74e8-8c06-e2cdf9df4d82",
        "storage_key": "property/5757666374713344/019f14fe-5572-74e8-8c06-e2cdf9df4d82.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.toyota.com/usa/operations/map/tmmtx",
      "poi_directions_map_url": "https://maps.google.com/?cid=3739277978480632304&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "toyota-motor-manufacturing-texas-inc",
      "poi_latitude": "29.2574587",
      "poi_longitude": "-98.5429684",
      "poi_miles_from_property": "21.7 mi",
      "poi_walking_minutes": "8 hours 2 mins",
      "poi_biking_minutes": "2 hours 14 mins",
      "poi_driving_minutes": "36 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f14fb-e0ee-76ca-a881-f4e43cbd8c14.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fb-e0ee-76ca-a881-f4e43cbd8c14",
        "storage_key": "property/5757666374713344/019f14fb-e0ee-76ca-a881-f4e43cbd8c14.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJt-W_7exWXIYR8GHHh4KV5DM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "ec_de12c1e7754a265eb4715d5c",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "source": "generator",
      "poi_name": "Methodist Hospital",
      "poi_type": "Major Employers & Offices",
      "poi_address": "7700 Floyd Curl Dr Main Entrance, San Antonio, TX 78229, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f14fb-aeb5-771d-9461-93593a77d758.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fb-aeb5-771d-9461-93593a77d758",
        "storage_key": "property/5757666374713344/019f14fb-aeb5-771d-9461-93593a77d758.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.sahealth.com/locations/methodist-hospital?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=4237917064766506362&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "methodist-hospital",
      "poi_latitude": "29.5083177",
      "poi_longitude": "-98.5718972",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 210-575-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f14fb-e050-701c-95ec-e23d784207a2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fb-e050-701c-95ec-e23d784207a2",
        "storage_key": "property/5757666374713344/019f14fb-e050-701c-95ec-e23d784207a2.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJt6o3IP5dXIYRekX58B0b0Do",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_69a173d79e4fad8d3297bb33",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "source": "generator",
      "poi_name": "Audie L. Murphy VA Medical Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "7400 Merton Minter, San Antonio, TX 78229, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f14fe-573d-72c3-ba1b-3ee8d922880b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f14fe-573d-72c3-ba1b-3ee8d922880b",
        "storage_key": "property/5757666374713344/019f14fe-573d-72c3-ba1b-3ee8d922880b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.southtexas.va.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1947626958282587042&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "audie-l-murphy-va-medical-center",
      "poi_latitude": "29.5067294",
      "poi_longitude": "-98.579854",
      "poi_miles_from_property": "3.0 mi",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 210-617-5300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f14fe-5ede-75ef-99b8-e35fd634f5aa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019f14fe-5ede-75ef-99b8-e35fd634f5aa",
        "storage_key": "property/5757666374713344/019f14fe-5ede-75ef-99b8-e35fd634f5aa.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJFaOOcPldXIYRontoS2ZcBxs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    }
  ],
  "office_hours": [
    {
      "id": "custom_49047eca-3de7-41d2-8349-c2643c74e383",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    },
    {
      "id": "custom_74526a91-a5e3-4a50-a6ba-0bf8a32311ca",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "day": "MON",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "custom_9f2d83bb-113c-4211-907f-29f17ef42595",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "day": "TUE",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "custom_49d1b0a0-4f4d-4886-abc8-f3952f04ae9f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "day": "WED",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "custom_b9bd0c37-011c-4f25-8818-a33e10b6ed88",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "day": "THU",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "custom_1544230d-5a73-4a7b-b2d5-36f2f4b2b85d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "day": "FRI",
      "open_time": "08:30",
      "close_time": "17:30"
    }
  ],
  "reviews": [
    {
      "id": "custom_c44fb2fc-061d-4ad8-a5ac-704ff12fee1d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "rating": "5.0",
      "name": "Nancy Chavarria",
      "text": "Today marks one year of residency at Palmetto Pointe Apartments, where I have thoroughly enjoyed my living experience. The environment is warm and inviting, the staff is exceptionally friendly, maintenance is efficient, and the amenities are outstanding. Personally, I have appreciated the serene nights spent by the fire pit and fireplace. I wholeheartedly recommend Palmetto Pointe Apartments.",
      "date": "2025-11-01",
      "title": ""
    },
    {
      "id": "custom_94136796-f43a-493b-ab1d-18a55f9c06d6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "rating": "5.0",
      "name": "tushar sonar",
      "text": "Palmetto Pointe has been a great place to live. The management team is responsive and friendly, and maintenance issues are resolved quickly. The property is clean, peaceful, and family-friendly. Parking is convenient, and the location makes commuting easy. I would definitely recommend this community to anyone looking for a calm and well-managed apartment complex.\n\nThanks to Katherine, Denis & Joselyn for effectively handling all queries and always being helpful",
      "date": "2026-01-18",
      "title": ""
    },
    {
      "id": "custom_6ee58f3b-2912-4e9c-9e25-d77f0d7079a4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "rating": "5.0",
      "name": "Donnie M",
      "text": "This complex is AMAZING. The staff have all been very friendly and helpful with my move in. This is luxury living just as they stated. The fixtures and appliances are all upgraded. I moved in and completely felt at home. The landscaping is very well maintained. They have two dog parks, one for large dogs and a small dog park. Thank you to my leasing agent Deniss Guerra. I can't wait to spring and summer to take advantage of the pool and outdoor kitchen areas.",
      "date": "2024-01-07",
      "title": ""
    },
    {
      "id": "custom_0f23010c-c945-4a27-877c-25605fc15571",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "rating": "5.0",
      "name": "Jorge Garza",
      "text": "Ms. Jessica Espinoza, the Assistant Manager for Palmetto Point Premier Apartments is a very unique, friendly and enjoyable individual to speak with. She is very knowledgeable with this apartment complex, and to my satisfaction, she answered all of my questions regarding the apartment complex and my apartment unit as well. Additionally, I often go to the office and find both Ms. Espinoza and Ms. Guerra busy with current and potential tenants. When I applied as a tenant, I could not upload my proof of income into the system for review and approval. I was assisted in the office and was taught how to upload the documentation needed for my approval. Furthermore, and it is a great asset, there is a Starbucks coffee maker in the kitchen and I often go to have a double shot espresso and always see both Ms. Espinoza and Ms. Guerra assisting potential and current tenants. This an awesome team that is here!",
      "date": "2023-10-11",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "ec_9089005911894e6dbbafa418",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "source": "generator",
      "url_health_error": "false",
      "virtual_tour_description": "YouTube channel: American Landmark",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f14c3-a70a-7691-93f2-1f691f91fc3e.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f14c3-a70a-7691-93f2-1f691f91fc3e",
        "storage_key": "property/5757666374713344/019f14c3-a70a-7691-93f2-1f691f91fc3e.webp",
        "width": 480,
        "height": 360
      },
      "virtual_tour_title": "Palmetto Pointe Community Tour",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://www.youtube.com/embed/PcHhCzaPOoo"
    }
  ],
  "faqs": [],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "0198aa45-e44d-7285-b041-29ecc24ebdd9",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "palmetto-pointe",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344"
    },
    {
      "lead_collector_id": "0198aa45-e4b2-72c3-8f34-f7664df86cc4",
      "lead_source": "FACEBOOK_ADS",
      "name": "palmetto-pointe",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344"
    },
    {
      "lead_collector_id": "0198aa45-e516-757f-a2b7-f183a0330704",
      "lead_source": "LANDING_PAGE",
      "name": "palmetto-pointe",
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "source": "custom",
      "page_item_url": "palmetto-pointe-in-unit-laundry-apartments-364",
      "search_query": "apartments with in-unit laundry in San Antonio",
      "category": "Amenity",
      "h1_title": "Palmetto Pointe Apartments with In-Unit Laundry",
      "h2_subtitle": "Discover the convenience of apartments with in-unit laundry at Palmetto Pointe in San Antonio. Experience modern amenities in our vibrant community today.",
      "page_copy": "Welcome to Palmetto Pointe in San Antonio, where modern conveniences blend seamlessly with exceptional living. Our apartments with in-unit laundry are designed to simplify your daily routine, offering the perfect blend of style and functionality. Choose from our spacious one and two-bedroom floor plans, each outfitted with chic quartz countertops, stainless steel appliances, and ample storage in the form of generous walk-in closets.\n\nBeyond the comfort of your own unit, enjoy a variety of amenities including a refreshing pool, a fully-equipped fitness center, and a stylish outdoor kitchen. Located in the bustling Medical Center neighborhood, Palmetto Pointe provides easy access to nearby shopping, dining, and entertainment options. Come and make Palmetto Pointe your new home, where each day starts and ends with unrivaled comfort and convenience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f6c10-3356-769c-847f-43bf30d39829.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool and lounge area at sunset.",
        "public_id": "019f6c10-3356-769c-847f-43bf30d39829",
        "storage_key": "property/5757666374713344/019f6c10-3356-769c-847f-43bf30d39829.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Palmetto Pointe Apartments with In-Unit Laundry",
      "seo_description": "Discover Palmetto Pointe with in-unit laundry in San Antonio featuring modern amenities. Tour our vibrant community today.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "source": "custom",
      "page_item_url": "palmetto-pointe-luxury-apartments-resort-pool-466",
      "search_query": "luxury apartments with resort-inspired pool 78240",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with Resort-Inspired Pool",
      "h2_subtitle": "Experience luxury living in 78240 with our resort-inspired pool. Discover upscale amenities at Palmetto Pointe today.",
      "page_copy": "At Palmetto Pointe, situated in the heart of San Antonio's 78240 area, discover luxury apartments equipped with a resort-inspired pool that elevates your living experience. Our chic one and two-bedroom residences boast upscale finishes such as quartz countertops and stainless steel appliances, ensuring every day is filled with comfort and style. \n\nResidents indulge in a suite of premier amenities, including a stunning dual-sided outdoor fireplace with flat screen TVs for perfect evenings, a cutting-edge fitness center, and a modern outdoor kitchen ideal for gatherings. Nestled in the vibrant Medical Center neighborhood, Palmetto Pointe offers both tranquility and convenience, making it the ideal choice for luxury living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f6c10-3356-769c-847f-43bf30d39829.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool and lounge area at sunset.",
        "public_id": "019f6c10-3356-769c-847f-43bf30d39829",
        "storage_key": "property/5757666374713344/019f6c10-3356-769c-847f-43bf30d39829.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments with Resort Pool in 78240",
      "seo_description": "Discover luxury living with a resort-inspired pool in 78240 at Palmetto Pointe. Experience upscale amenities and a vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "source": "custom",
      "page_item_url": "palmetto-pointe-dog-friendly-apartments-medical-center-622",
      "search_query": "dog-friendly apartments with pet play area Medical Center",
      "category": "Amenity",
      "h1_title": "Dog-Friendly Apartments with Pet Play Area",
      "h2_subtitle": "Explore dog-friendly apartments with a pet play area at Palmetto Pointe in the Medical Center. Discover the perfect home for you and your pet.",
      "page_copy": "Discover the perfect home for you and your four-legged friends at Palmetto Pointe in San Antonio's Medical Center. Our dog-friendly apartments come complete with a dedicated pet play area, ensuring both you and your pets enjoy an active and fulfilling lifestyle. Choose from spacious one and two-bedroom layouts that feature modern conveniences like stainless steel appliances and ample storage with generous walk-in closets.\n\nAt Palmetto Pointe, we understand the importance of community and comfort. Enjoy a variety of amenities including a beautiful pool, an innovative fitness center, and an inviting dual-sided outdoor fireplace. Located in a bustling, pet-friendly neighborhood, our exceptional living experience promises convenience, style, and fun for everyone in the family—including your furry companions.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f6c10-3356-769c-847f-43bf30d39829.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool and lounge area at sunset.",
        "public_id": "019f6c10-3356-769c-847f-43bf30d39829",
        "storage_key": "property/5757666374713344/019f6c10-3356-769c-847f-43bf30d39829.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dog-Friendly Apartments with Pet Play in Medical Center",
      "seo_description": "Explore dog-friendly apartments with a pet play area at Palmetto Pointe in Medical Center, San Antonio. Perfect for you and your pet!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "source": "custom",
      "page_item_url": "palmetto-pointe-fitness-center-apartments-bexar-county-398",
      "search_query": "modern fitness center apartments Bexar County",
      "category": "Amenity",
      "h1_title": "Modern Fitness Center Apartments in Bexar County",
      "h2_subtitle": "Elevate your lifestyle in Bexar County with Palmetto Pointe's modern fitness center. Discover premium apartment living today.",
      "page_copy": "Palmetto Pointe offers exceptional apartment living in Bexar County, featuring a state-of-the-art modern fitness center designed to keep you active and healthy. Our spacious one and two-bedroom units boast stylish finishes like quartz countertops and stainless steel appliances, perfect for those seeking both luxury and convenience.\n\nBeyond personal fitness options, the community amenities include a refreshing swimming pool, a versatile outdoor kitchen, and a welcoming dual-sided fireplace. Nestled in San Antonio's vibrant Medical Center neighborhood, Palmetto Pointe offers an ideal blend of comfort, style, and location. Discover what makes our community the perfect choice for modern living and a healthy lifestyle.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f6c10-3356-769c-847f-43bf30d39829.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool and lounge area at sunset.",
        "public_id": "019f6c10-3356-769c-847f-43bf30d39829",
        "storage_key": "property/5757666374713344/019f6c10-3356-769c-847f-43bf30d39829.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Modern Fitness Center Apartments in Bexar County",
      "seo_description": "Experience modern fitness center living at Palmetto Pointe in Bexar County. Discover premium apartment amenities and vibrant community life.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "source": "custom",
      "page_item_url": "palmetto-pointe-air-conditioning-parking-apartments-438",
      "search_query": "apartments with air conditioning and parking in San Antonio",
      "category": "Amenity",
      "h1_title": "Apartments with Air Conditioning and Parking",
      "h2_subtitle": "Find comfort with air-conditioned apartments and convenient parking at Palmetto Pointe in San Antonio. Discover modern living today.",
      "page_copy": "Welcome to Palmetto Pointe, where comfort meets convenience in San Antonio. Our apartments are equipped with efficient air conditioning systems to ensure a pleasant environment year-round. Additionally, we offer ample parking solutions, making your daily commute seamless and stress-free.\n\nPalmetto Pointe presents modern living with stylish one and two-bedroom options, each featuring quartz countertops and stainless steel appliances. Enjoy luxury amenities like a sparkling pool, a dual-sided outdoor fireplace, and a sophisticated fitness center. Nestled in the lively Medical Center neighborhood, our community offers a perfect mix of amenities, style, and location for those seeking an exceptional living experience in San Antonio.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f6c10-3356-769c-847f-43bf30d39829.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool and lounge area at sunset.",
        "public_id": "019f6c10-3356-769c-847f-43bf30d39829",
        "storage_key": "property/5757666374713344/019f6c10-3356-769c-847f-43bf30d39829.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with A/C and Parking in San Antonio",
      "seo_description": "Discover San Antonio living at Palmetto Pointe, featuring apartments with air conditioning and parking. Enjoy comfort and convenience all in one place.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "source": "custom",
      "page_item_url": "palmetto-pointe-one-bedroom-medical-center-san-antonio-363",
      "search_query": "one bedroom apartments medical center san antonio",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Medical Center",
      "h2_subtitle": "Discover spacious one bedroom apartments at Palmetto Pointe, nestled in San Antonio's bustling Medical Center neighborhood.",
      "page_copy": "Experience modern living in the heart of San Antonio's Medical Center with Palmetto Pointe's one bedroom apartments. Designed with contemporary elegance, these units feature luxurious details such as quartz countertops and stainless steel appliances, providing both style and functionality.\n\nBeyond your personal haven, enjoy a selection of community amenities including a refreshing pool, dual-sided outdoor fireplace, and a cutting-edge fitness center. Palmetto Pointe offers more than just a home—it's a lifestyle. Its prime location in the Medical Center ensures you're always close to work, retail, and dining options, making it the perfect choice for comfortable and convenient living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f6c10-3356-769c-847f-43bf30d39829.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool and lounge area at sunset.",
        "public_id": "019f6c10-3356-769c-847f-43bf30d39829",
        "storage_key": "property/5757666374713344/019f6c10-3356-769c-847f-43bf30d39829.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Medical Center, San Antonio",
      "seo_description": "Explore one bedroom apartments at Palmetto Pointe in San Antonio's Medical Center. Enjoy modern amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "source": "custom",
      "page_item_url": "palmetto-pointe-two-bedroom-78240-117",
      "search_query": "two bedroom apartments near 78240",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments Near 78240",
      "h2_subtitle": "Find spacious two bedroom apartments close to the 78240 area at Palmetto Pointe, offering modern amenities and comfort.",
      "page_copy": "Discover the ideal two bedroom apartments near the 78240 area at Palmetto Pointe in San Antonio. Our spacious and elegantly designed units feature high-end finishes like quartz countertops and stainless steel appliances, perfect for those who desire a touch of luxury in their living space.\n\nPalmetto Pointe further enhances your living experience with premium amenities such as a refreshing swimming pool, dual-sided outdoor fireplace, and a state-of-the-art fitness center. Located in the vibrant Medical Center neighborhood, our community provides easy access to local dining, shopping, and healthcare facilities, ensuring a balanced and fulfilling lifestyle. Visit us and see why Palmetto Pointe is the perfect choice for comfortable two bedroom living near 78240.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f6c10-3356-769c-847f-43bf30d39829.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool and lounge area at sunset.",
        "public_id": "019f6c10-3356-769c-847f-43bf30d39829",
        "storage_key": "property/5757666374713344/019f6c10-3356-769c-847f-43bf30d39829.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments Near 78240",
      "seo_description": "Explore two bedroom apartments at Palmetto Pointe near 78240. Enjoy modern amenities and a convenient location in San Antonio.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "source": "custom",
      "page_item_url": "palmetto-pointe-near-ut-health-science-center-san-antonio-321",
      "search_query": "apartments near UT Health Science Center San Antonio",
      "category": "School",
      "h1_title": "Apartments Near UT Health Science Center",
      "h2_subtitle": "Palmetto Pointe offers modern apartments close to UT Health Science Center San Antonio, perfect for students and staff.",
      "page_copy": "Located conveniently near the UT Health Science Center San Antonio, Palmetto Pointe offers an ideal living solution for students and professionals alike. Our one and two-bedroom apartments feature stylish interiors with quartz countertops and state-of-the-art stainless steel appliances, creating a comfortable and modern home environment.\n\nEnjoy a range of community amenities designed to enhance your lifestyle, including a refreshing swimming pool, a dual-sided outdoor fireplace, and a well-equipped fitness center. Situated in the vibrant Medical Center neighborhood, Palmetto Pointe provides easy access to educational facilities, dining, and shopping, making it the perfect choice for those seeking proximity to UT Health Science Center with the benefits of luxurious apartment living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f6c10-3356-769c-847f-43bf30d39829.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool and lounge area at sunset.",
        "public_id": "019f6c10-3356-769c-847f-43bf30d39829",
        "storage_key": "property/5757666374713344/019f6c10-3356-769c-847f-43bf30d39829.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near UT Health Science Center",
      "seo_description": "Find modern apartments at Palmetto Pointe near UT Health Science Center San Antonio. Ideal for students and professionals.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "source": "custom",
      "page_item_url": "palmetto-pointe-near-utsa-main-campus-122",
      "search_query": "apartments close to UTSA Main Campus",
      "category": "School",
      "h1_title": "Apartments Near UTSA Main Campus",
      "h2_subtitle": "Discover convenient apartments near UTSA Main Campus at Palmetto Pointe, providing both comfort and modern amenities.",
      "page_copy": "Palmetto Pointe offers the perfect balance of convenience and luxury for those looking for apartments close to UTSA Main Campus. Our community features a variety of one and two-bedroom floor plans, all designed with modern living in mind. Enjoy premium finishes like quartz countertops and stainless steel appliances that elevate your living experience.\n\nIn addition to beautifully appointed apartments, Palmetto Pointe boasts an array of amenities including a vibrant swimming pool, a dual-sided outdoor fireplace, and a fully equipped fitness center. Nestled in the bustling Medical Center neighborhood, our location provides quick access to UTSA Main Campus, making it a prime choice for students and staff seeking a comfortable, modern home base close to campus activities and resources.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f6c10-3356-769c-847f-43bf30d39829.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool and lounge area at sunset.",
        "public_id": "019f6c10-3356-769c-847f-43bf30d39829",
        "storage_key": "property/5757666374713344/019f6c10-3356-769c-847f-43bf30d39829.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near UTSA Main Campus",
      "seo_description": "Explore apartments at Palmetto Pointe near UTSA Main Campus. Perfect for students and staff with modern amenities and convenient location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "source": "custom",
      "page_item_url": "palmetto-pointe-near-st-marys-university-209",
      "search_query": "apartment living near St. Mary's University San Antonio",
      "category": "School",
      "h1_title": "Apartment Living Near St. Mary's University",
      "h2_subtitle": "Experience apartment living near St. Mary's University at Palmetto Pointe, offering convenience and modern amenities.",
      "page_copy": "Enjoy the benefits of apartment living near St. Mary's University when you choose Palmetto Pointe as your new home. Our community provides stylish one and two-bedroom apartments, thoughtfully designed with luxury finishes like quartz countertops and sleek stainless steel appliances, perfect for students and faculty seeking a comfortable living environment.\n\nBeyond the comfort of your apartment, Palmetto Pointe offers premium amenities such as a sparkling pool, a modern fitness center, and a dual-sided outdoor fireplace, enhancing your living experience. Situated in the lively Medical Center neighborhood, our location ensures easy access to both St. Mary's University and an array of dining and shopping options, making it a prime spot for students and professionals alike.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f6c10-3356-769c-847f-43bf30d39829.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool and lounge area at sunset.",
        "public_id": "019f6c10-3356-769c-847f-43bf30d39829",
        "storage_key": "property/5757666374713344/019f6c10-3356-769c-847f-43bf30d39829.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartment Living Near St. Mary's University",
      "seo_description": "Discover apartment living at Palmetto Pointe near St. Mary's University San Antonio, with modern amenities and a convenient location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "source": "custom",
      "page_item_url": "palmetto-pointe-near-st-matthews-catholic-church-school-293",
      "search_query": "rentals near St Matthew's Catholic Church school San Antonio",
      "category": "School",
      "h1_title": "Rentals Near St. Matthew's Catholic Church",
      "h2_subtitle": "Discover rentals near St. Matthew's Catholic Church school at Palmetto Pointe, perfect for convenience and modern living.",
      "page_copy": "Palmetto Pointe offers an ideal option for those looking for rentals near St. Matthew's Catholic Church school in San Antonio. Our community features modern one and two-bedroom apartments with high-end finishes like quartz countertops and stainless steel appliances, ensuring a comfortable living experience.\n\nWith a range of community amenities such as a refreshing pool, a fully equipped fitness center, and a dual-sided outdoor fireplace, Palmetto Pointe enhances your lifestyle. Located in the vibrant Medical Center neighborhood, you'll enjoy easy access to nearby schools, dining, and shopping options. This makes it an excellent choice for families and professionals seeking proximity to St. Matthew's Catholic Church school.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f6c10-3356-769c-847f-43bf30d39829.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool and lounge area at sunset.",
        "public_id": "019f6c10-3356-769c-847f-43bf30d39829",
        "storage_key": "property/5757666374713344/019f6c10-3356-769c-847f-43bf30d39829.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rentals Near St. Matthew's Catholic Church",
      "seo_description": "Find rentals at Palmetto Pointe near St. Matthew's Catholic Church school San Antonio, offering modern living and convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "source": "custom",
      "page_item_url": "palmetto-pointe-near-christian-school-castle-hills-213",
      "search_query": "apartments by The Christian School at Castle Hills",
      "category": "School",
      "h1_title": "Apartments by The Christian School at Castle Hills",
      "h2_subtitle": "Explore apartments by The Christian School at Castle Hills at Palmetto Pointe, offering a blend of comfort and convenience.",
      "page_copy": "Palmetto Pointe is an excellent choice for those seeking apartments by The Christian School at Castle Hills. Offering spacious one and two-bedroom floor plans, our community caters to families and professionals alike, with modern amenities and premium finishes like quartz countertops and stainless steel appliances.\n\nExperience elevated living with our range of amenities including a sparkling pool, a state-of-the-art fitness center, and a dual-sided outdoor fireplace. Located in the dynamic Medical Center area, Palmetto Pointe places you just moments away from The Christian School at Castle Hills and various local attractions, creating a perfect balance of comfort and accessibility.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f6c10-3356-769c-847f-43bf30d39829.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool and lounge area at sunset.",
        "public_id": "019f6c10-3356-769c-847f-43bf30d39829",
        "storage_key": "property/5757666374713344/019f6c10-3356-769c-847f-43bf30d39829.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments by The Christian School at Castle Hills",
      "seo_description": "Discover comfort and convenience at Palmetto Pointe apartments by The Christian School at Castle Hills, with modern amenities and ideal location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "source": "custom",
      "page_item_url": "palmetto-pointe-near-cornerstone-christian-schools-224",
      "search_query": "apartment homes close to Cornerstone Christian Schools San Antonio",
      "category": "School",
      "h1_title": "Apartment Homes Close to Cornerstone Christian",
      "h2_subtitle": "Find apartment homes close to Cornerstone Christian Schools at Palmetto Pointe, where comfort meets convenience in San Antonio.",
      "page_copy": "Palmetto Pointe offers stunning apartment homes close to Cornerstone Christian Schools, making it an ideal location for families and professionals alike. Our spacious one and two-bedroom apartments feature stylish designs with quartz countertops and stainless steel appliances, providing a modern living experience.\n\nResidents enjoy access to a variety of amenities, including a refreshing pool, a well-equipped fitness center, and a dual-sided outdoor fireplace perfect for relaxation and socializing. Located in the vibrant Medical Center neighborhood, Palmetto Pointe ensures easy access to Cornerstone Christian Schools and a host of dining and shopping options, offering the ideal blend of comfort and convenience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f6c10-3356-769c-847f-43bf30d39829.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool and lounge area at sunset.",
        "public_id": "019f6c10-3356-769c-847f-43bf30d39829",
        "storage_key": "property/5757666374713344/019f6c10-3356-769c-847f-43bf30d39829.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartment Homes Near Cornerstone Christian",
      "seo_description": "Discover apartment homes at Palmetto Pointe near Cornerstone Christian Schools San Antonio, featuring modern amenities and prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "source": "custom",
      "page_item_url": "palmetto-pointe-near-tohui-language-academy-27",
      "search_query": "apartments near Tohui Language Academy",
      "category": "School",
      "h1_title": "Apartments Near Tohui Language Academy",
      "h2_subtitle": "Explore apartments near Tohui Language Academy at Palmetto Pointe, where modern living meets strategic location in San Antonio.",
      "page_copy": "Palmetto Pointe is the perfect community for those seeking apartments near Tohui Language Academy. Our one and two-bedroom apartments feature contemporary designs with luxury finishes such as quartz countertops and stainless steel appliances, catering to your every need.\n\nEnjoy the splendid community amenities at Palmetto Pointe, including a relaxing pool, comprehensive fitness center, and a cozy dual-sided outdoor fireplace. Located in the thriving Medical Center area, our community provides convenient access to Tohui Language Academy and various local attractions, making it the ideal choice for students and educators looking for a seamless blend of comfort and proximity.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f6c10-3356-769c-847f-43bf30d39829.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool and lounge area at sunset.",
        "public_id": "019f6c10-3356-769c-847f-43bf30d39829",
        "storage_key": "property/5757666374713344/019f6c10-3356-769c-847f-43bf30d39829.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Tohui Language Academy",
      "seo_description": "Find modern apartments at Palmetto Pointe near Tohui Language Academy, offering convenience and comfort in San Antonio.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "source": "custom",
      "page_item_url": "palmetto-pointe-rentals-near-st-george-episcopal-520",
      "search_query": "rentals by St. George Episcopal School San Antonio",
      "category": "School",
      "h1_title": "Rentals by St. George Episcopal School",
      "h2_subtitle": "Discover rentals by St. George Episcopal School at Palmetto Pointe, where comfort and convenience are paramount.",
      "page_copy": "Palmetto Pointe provides the ideal rentals for those looking to live near St. George Episcopal School in San Antonio. Our stylish one and two-bedroom floor plans feature premium finishes like quartz countertops and stainless steel appliances, ensuring modern comfort.\n\nResidents can enjoy a variety of amenities, including a pristine pool, a state-of-the-art fitness center, and a welcoming dual-sided outdoor fireplace. Positioned in the bustling Medical Center area, Palmetto Pointe offers a strategic location with easy access to St. George Episcopal School, making it a prime choice for families and educators. Experience the perfect balance of luxury and convenience at our community.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f6c10-3356-769c-847f-43bf30d39829.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool and lounge area at sunset.",
        "public_id": "019f6c10-3356-769c-847f-43bf30d39829",
        "storage_key": "property/5757666374713344/019f6c10-3356-769c-847f-43bf30d39829.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rentals Near St. George Episcopal School",
      "seo_description": "Explore rentals at Palmetto Pointe near St. George Episcopal School, featuring modern amenities and strategic location in San Antonio.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5695708787113984",
      "property_id": "5757666374713344",
      "source": "custom",
      "page_item_url": "palmetto-pointe-listings-near-lutheran-high-school-91",
      "search_query": "apartment listings near Lutheran High School Bexar County",
      "category": "School",
      "h1_title": "Apartment Listings Near Lutheran High School",
      "h2_subtitle": "Explore apartment listings near Lutheran High School at Palmetto Pointe, offering luxury and convenience in Bexar County.",
      "page_copy": "Palmetto Pointe features exceptional apartment listings near Lutheran High School, perfect for families and students seeking a home in Bexar County. Each one and two-bedroom apartment boasts high-end finishes such as quartz countertops and stainless steel appliances, providing an elegant living environment.\n\nCommunity amenities include a sparkling pool, modern fitness center, and a cozy dual-sided outdoor fireplace, ensuring relaxation and enjoyment. Situated in the dynamic Medical Center neighborhood, our community offers convenient access to Lutheran High School and the surrounding attractions, establishing Palmetto Pointe as a top choice for comfortable and convenient living in Bexar County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5757666374713344/019f6c10-3356-769c-847f-43bf30d39829.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool and lounge area at sunset.",
        "public_id": "019f6c10-3356-769c-847f-43bf30d39829",
        "storage_key": "property/5757666374713344/019f6c10-3356-769c-847f-43bf30d39829.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartment Listings Near Lutheran High School",
      "seo_description": "Discover Palmetto Pointe's apartment listings near Lutheran High School, offering a prime location and luxurious amenities in Bexar County.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "jordanh@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "2183"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "2376471185"
    },
    {
      "ID": "custom_leasing_ai",
      "type": "STRING",
      "value": "<script async src=\"https://cdn.leasing.ai/prod/v1/loader.js?pid=69db514f9eb73dfa48ba5a3f\"></script>\n<img src=\"https://api.leasing.ai/v1/widgets/pixel/69db514f9eb73dfa48ba5a3f\" width=\"1\" height=\"1\" style=\"display:none\" alt=\"\" />"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "4878141"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-T92GP6P"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "2"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "full_stack"
    },
    {
      "ID": "custom_knock_company_id",
      "type": "STRING",
      "value": "3165"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "8443907421"
    },
    {
      "ID": "custom_knock_community_id",
      "type": "STRING",
      "value": "262bc1011f1edf70"
    },
    {
      "ID": "custom_knock_company_token",
      "type": "STRING",
      "value": "1f195820242ac1100a1b122d7087a021"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_engrain_sightmap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/8epmyr04p6d"
    },
    {
      "ID": "custom_self_guided_tour_url",
      "type": "STRING",
      "value": "https://selftournow.com/property/138ffc70-3026-4052-a2b3-3e4f3094cad0"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "custom"
    },
    {
      "ID": "custom_knock_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "830-271-4564"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IlkzMEk5Yllsd1JXajN6Y2hLZ2ZWemc9PSIsInZhbHVlIjoicVhxcGhMS2RrbXBVSm9ROXArVG1GUT09IiwibWFjIjoiZTEzZWIwMDZjNmFhZGQwNDAzMzZhMjBlNDZmY2YyOTliMjIyNjhmMWVlYjRmYjZjMTNhMzYyMjgzMWZlYWNjNyJ9"
    },
    {
      "ID": "custom_household_income_qualification_multiplier",
      "type": "FLOAT",
      "value": "3"
    }
  ],
  "custom_csm": "jordanh@repli360.com",
  "custom_qb_id": "2183",
  "custom_repli_id": "2376471185",
  "custom_leasing_ai": "<script async src=\"https://cdn.leasing.ai/prod/v1/loader.js?pid=69db514f9eb73dfa48ba5a3f\"></script>\n<img src=\"https://api.leasing.ai/v1/widgets/pixel/69db514f9eb73dfa48ba5a3f\" width=\"1\" height=\"1\" style=\"display:none\" alt=\"\" />",
  "custom_realpage_id": "4878141",
  "custom_google_gtm_id": "GTM-T92GP6P",
  "custom_rollout_phase": "2",
  "custom_ads_subscription": "full_stack",
  "custom_knock_company_id": "3165",
  "custom_seo_subscription": "essential",
  "custom_hubspot_company_id": "8443907421",
  "custom_knock_community_id": "262bc1011f1edf70",
  "custom_knock_company_token": "1f195820242ac1100a1b122d7087a021",
  "custom_social_subscription": "none",
  "custom_engrain_sightmap_url": "https://sightmap.com/embed/8epmyr04p6d",
  "custom_self_guided_tour_url": "https://selftournow.com/property/138ffc70-3026-4052-a2b3-3e4f3094cad0",
  "custom_website_subscription": "custom",
  "custom_knock_tour_button_popup": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>",
  "custom_ppc_tracking_phone_number": "830-271-4564",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IlkzMEk5Yllsd1JXajN6Y2hLZ2ZWemc9PSIsInZhbHVlIjoicVhxcGhMS2RrbXBVSm9ROXArVG1GUT09IiwibWFjIjoiZTEzZWIwMDZjNmFhZGQwNDAzMzZhMjBlNDZmY2YyOTliMjIyNjhmMWVlYjRmYjZjMTNhMzYyMjgzMWZlYWNjNyJ9",
  "custom_household_income_qualification_multiplier": "3"
};

export const generatedAt = '2026-11-02T21:16:29.573Z';
